var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScientLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 808.7 183.6",
    enableBackground: "new 0 0 808.7 183.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "first_S",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    d: "M112.3,8l19.3,3.8l7,2.9l6.7,1.9l8.7-3.1 l2.2,3.5l-0.2,8.5l0.2,3.8l1.4,10.3l1,9.6l0.2,2.1l-2.6,4.5l-2.7-4l-15.4-25.3l-26.1-10.7l-16.5,6.4l-7,15.1l6.2,13.9l24.9,12.3 l33,20l9.6,28.4L149,143.5l-31,13.5l-23-4.9l-10.8-3.1l-5.6-1.8l-1.3-5.4l-3.1-14.3l-4-18.3l5.4-2.5l17.9,30.3l26.4,12.3l19-8.1 l8.4-18.6l-4.4-13.6l-15.1-10l-16-7.1L81,72.6l-8.1-23.9l11.3-29L112.3,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    points: "112.3,8 131.6,11.8 138.6,14.8  145.3,16.7 154.1,13.5 156.3,17 156.1,25.5 156.3,29.3 157.6,39.5 158.7,49.1 158.9,51.2 156.3,55.7 153.6,51.7 138.2,26.4  112.1,15.7 95.6,22.1 88.6,37.1 94.8,51.1 119.7,63.3 152.7,83.3 162.3,111.6 149,143.5 118.1,157 95.1,152.1 84.3,148.9  78.6,147.1 77.3,141.7 74.2,127.4 70.2,109.1 75.6,106.6 93.4,136.9 119.8,149.1 138.8,141 147.1,122.4 142.8,108.8  127.7,98.8 111.7,91.7 81,72.6 72.9,48.7 84.2,19.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1921 -0.9814 0.9814 0.1921 82.8229 116.6965)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9235 -0.3835 0.3835 0.9235 5.4999 43.6789)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })))))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 109.1,
    x2: 75.6,
    y2: 106.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -39.8626 40.3922)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -38.2725 42.4354)",
    cx: 75.6,
    cy: 106.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 91.8,
    y1: 146.2,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -61.0831 66.0068)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -45.3778 50.1324)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 78.6,
    y1: 147.1,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.956132e-02 6.956132e-02 0.9976 -10.0414 5.8271)",
    cx: 78.6,
    cy: 147.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.955907e-02 6.955907e-02 0.9976 -9.9458 6.7365)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 118.1,
    y1: 157,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3807 -0.9247 0.9247 0.3807 -72.0727 206.4049)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3808 -0.9247 0.9247 0.3808 -78.3481 175.3658)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.8,
    y1: 149.1,
    x2: 118.1,
    y2: 157
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -51.7202 233.8399)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -60.7742 238.3055)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 119.8,
    y2: 149.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -24.6115 31.035)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -26.2286 25.5692)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.8,
    y1: 141,
    x2: 149,
    y2: 143.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -30.5266 243.4178)",
    cx: 138.8,
    cy: 141,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -25.0207 255.2617)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 147.1,
    y1: 122.4,
    x2: 162.3,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -43.7677 108.3983)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -34.6654 115.1743)",
    cx: 162.3,
    cy: 111.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -12.247 13.9206)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -10.3727 13.667)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 152.7,
    y1: 83.3,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 48.8081 222.7836)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 5.2607 250.955)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -10.3301 202.5937)",
    cx: 142.8,
    cy: 108.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 19.824 195.5237)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 127.7,
    y1: 98.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -32.8937 82.1504)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -20.9647 92.9988)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -16.0909 24.2259)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -13.5841 32.2621)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.1,73.2"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 109.1,
    y1: 73.2,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -9.2168 16.0888)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -11.7928 16.643)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -11.0967 98.4195)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -20.6361 93.8397)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -8.2817 81.7913)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -12.6618 122.4962)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 6.7567 152.0878)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 33.6575 180.7221)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 81,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 0.7432 103.4671)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 -23.7635 101.8277)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 88.6,
    y1: 37.1,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -4.7469 59.8774)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -14.6674 52.8444)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 84.2,
    y1: 19.7,
    x2: 88.6,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -2.2654 21.0115)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -6.3653 22.5898)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 95.6,
    y1: 22.1,
    x2: 84.2,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 54.4371 111.1647)",
    cx: 95.6,
    cy: 22.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 47.6967 98.1049)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.3,
    y1: 8,
    x2: 112.1,
    y2: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 101.8367 120.1343)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 94.0143 127.4699)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 131.6,
    y1: 11.8,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 6.857 55.3875)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 1.4329 59.4125)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.1,
    y1: 15.7,
    x2: 131.6,
    y2: 11.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -0.9073 22.2331)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 0.2285 25.9672)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -12.2308 62.8391)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -33.5128 89.9774)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 26.3139 161.3967)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 -6.7688 174.3845)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 157.6,
    y1: 39.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 36.5793 147.9773)",
    cx: 157.6,
    cy: 39.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 38.9201 126.0855)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 17,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 9.8406 74.1275)",
    cx: 156.3,
    cy: 17,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 3.4425 66.8391)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 154.1,
    y1: 13.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 25.9362 100.1191)",
    cx: 154.1,
    cy: 13.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 14.2673 92.9962)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.6,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 34.5216 131.4978)",
    cx: 156.3,
    cy: 29.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 39.2668 112.5572)",
    cx: 138.6,
    cy: 14.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 145.3,
    y1: 16.7,
    x2: 156.3,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 0.8918 39.8042)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 -9.2325 44.1998)",
    cx: 156.3,
    cy: 55.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 158.9,
    y1: 51.2,
    x2: 145.3,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 -7.718 61.6075)",
    cx: 158.9,
    cy: 51.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 3.9652 54.2631)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -57.8107 204.6665)",
    cx: 93.4,
    cy: 136.9,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -68.3293 210.6766)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 75.6,
    y1: 106.6,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 162.3,
    y1: 111.6,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 119.7,
    y2: 63.3
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 96.8,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 88.8,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.2,
    y1: 26.4,
    x2: 112.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.2,
    y2: 26.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.5966 175.869)",
    fontFamily: "'GoudyOldStyleT-Bold'",
    fontSize: "154.5575px"
  }, "SCIENT")), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 217.5953 232.6356)",
    fontFamily: "'GoudyOldStyleT-Bold'",
    fontSize: "50.8017px"
  }, "ASSET MANAGEMENT")), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    d: "M112.3,8l19.3,3.8l7,2.9l6.7,1.9l8.7-3.1 l2.2,3.5l-0.2,8.5l0.2,3.8l1.4,10.3l1,9.6l0.2,2.1l-2.6,4.5l-2.7-4l-15.4-25.3l-26.1-10.7l-16.5,6.4l-7,15.1l6.2,13.9l24.9,12.3 l33,20l9.6,28.4L149,143.5l-31,13.5l-23-4.9l-10.8-3.1l-5.6-1.8l-1.3-5.4l-3.1-14.3l-4-18.3l5.4-2.5l17.9,30.3l26.4,12.3l19-8.1 l8.4-18.6l-4.4-13.6l-15.1-10l-16-7.1L81,72.6l-8.1-23.9l11.3-29L112.3,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    points: "112.3,8 131.6,11.8 138.6,14.8  145.3,16.7 154.1,13.5 156.3,17 156.1,25.5 156.3,29.3 157.6,39.5 158.7,49.1 158.9,51.2 156.3,55.7 153.6,51.7 138.2,26.4  112.1,15.7 95.6,22.1 88.6,37.1 94.8,51.1 119.7,63.3 152.7,83.3 162.3,111.6 149,143.5 118.1,157 95.1,152.1 84.3,148.9  78.6,147.1 77.3,141.7 74.2,127.4 70.2,109.1 75.6,106.6 93.4,136.9 119.8,149.1 138.8,141 147.1,122.4 142.8,108.8  127.7,98.8 111.7,91.7 81,72.6 72.9,48.7 84.2,19.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1921 -0.9814 0.9814 0.1921 82.8229 116.6965)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9235 -0.3835 0.3835 0.9235 5.4999 43.6789)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })))))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 109.1,
    x2: 75.6,
    y2: 106.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -39.8626 40.3922)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -38.2725 42.4354)",
    cx: 75.6,
    cy: 106.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 91.8,
    y1: 146.2,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -61.0831 66.0068)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -45.3778 50.1324)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 78.6,
    y1: 147.1,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.956132e-02 6.956132e-02 0.9976 -10.0414 5.8271)",
    cx: 78.6,
    cy: 147.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.955907e-02 6.955907e-02 0.9976 -9.9458 6.7365)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 118.1,
    y1: 157,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3807 -0.9247 0.9247 0.3807 -72.0727 206.4049)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3808 -0.9247 0.9247 0.3808 -78.3481 175.3658)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.8,
    y1: 149.1,
    x2: 118.1,
    y2: 157
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -51.7202 233.8399)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -60.7742 238.3055)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 119.8,
    y2: 149.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -24.6115 31.035)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -26.2286 25.5692)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.8,
    y1: 141,
    x2: 149,
    y2: 143.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -30.5266 243.4178)",
    cx: 138.8,
    cy: 141,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -25.0207 255.2617)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 147.1,
    y1: 122.4,
    x2: 162.3,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -43.7677 108.3983)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -34.6654 115.1743)",
    cx: 162.3,
    cy: 111.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -12.247 13.9206)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -10.3727 13.667)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 152.7,
    y1: 83.3,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 48.8081 222.7836)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 5.2607 250.955)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -10.3301 202.5937)",
    cx: 142.8,
    cy: 108.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 19.824 195.5237)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 127.7,
    y1: 98.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -32.8937 82.1504)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -20.9647 92.9988)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -16.0909 24.2259)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -13.5841 32.2621)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.1,73.2"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 109.1,
    y1: 73.2,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -9.2168 16.0888)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -11.7928 16.643)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -11.0967 98.4195)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -20.6361 93.8397)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -8.2817 81.7913)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -12.6618 122.4962)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 6.7567 152.0878)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 33.6575 180.7221)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 81,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 0.7432 103.4671)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 -23.7635 101.8277)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 88.6,
    y1: 37.1,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -4.7469 59.8774)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -14.6674 52.8444)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 84.2,
    y1: 19.7,
    x2: 88.6,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -2.2654 21.0115)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -6.3653 22.5898)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 95.6,
    y1: 22.1,
    x2: 84.2,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 54.4371 111.1647)",
    cx: 95.6,
    cy: 22.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 47.6967 98.1049)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.3,
    y1: 8,
    x2: 112.1,
    y2: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 101.8367 120.1343)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 94.0143 127.4699)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 131.6,
    y1: 11.8,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 6.857 55.3875)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 1.4329 59.4125)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.1,
    y1: 15.7,
    x2: 131.6,
    y2: 11.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -0.9073 22.2331)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 0.2285 25.9672)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -12.2308 62.8391)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -33.5128 89.9774)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 26.3139 161.3967)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 -6.7688 174.3845)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 157.6,
    y1: 39.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 36.5793 147.9773)",
    cx: 157.6,
    cy: 39.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 38.9201 126.0855)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 17,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 9.8406 74.1275)",
    cx: 156.3,
    cy: 17,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 3.4425 66.8391)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 154.1,
    y1: 13.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 25.9362 100.1191)",
    cx: 154.1,
    cy: 13.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 14.2673 92.9962)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.6,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 34.5216 131.4978)",
    cx: 156.3,
    cy: 29.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 39.2668 112.5572)",
    cx: 138.6,
    cy: 14.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 145.3,
    y1: 16.7,
    x2: 156.3,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 0.8918 39.8042)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 -9.2325 44.1998)",
    cx: 156.3,
    cy: 55.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 158.9,
    y1: 51.2,
    x2: 145.3,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 -7.718 61.6075)",
    cx: 158.9,
    cy: 51.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 3.9652 54.2631)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -57.8107 204.6665)",
    cx: 93.4,
    cy: 136.9,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -68.3293 210.6766)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 75.6,
    y1: 106.6,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 162.3,
    y1: 111.6,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 119.7,
    y2: 63.3
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 96.8,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 88.8,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.2,
    y1: 26.4,
    x2: 112.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.2,
    y2: 26.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "test_goudy",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244,70.8c4.7,0,9.4,0.9,13.9,2.7l5.1,2.1c2.3,0.9,3.9,1.4,4.8,1.4c0.7,0,1.4-0.2,2.2-0.5l2.9-1.4 c0.4-0.2,0.8-0.3,1.2-0.3c1.1,0,1.6,0.8,1.6,2.5l-0.2,6.1c0,1,0,1.9,0.2,2.7l1,7.4l0.8,6.9c0.1,0.6,0.2,1.1,0.2,1.5 c0,2.2-0.6,3.2-1.9,3.2c-0.9,0-1.6-1-2-2.9c-1.5-7-5.1-13.1-11-18.2c-5.9-5.1-12.1-7.7-18.7-7.7c-4.5,0-8.5,1.5-11.9,4.6 c-3.4,3.1-5.1,6.7-5.1,10.8c0,3.9,1.5,7.2,4.5,10c1.9,1.8,7.9,4.8,17.9,8.8c4.8,2,9,3.9,12.5,5.8c5.2,2.9,9,5.7,11.3,8.5 c4.6,5.6,6.9,12.4,6.9,20.4c0,8.8-3.2,16.4-9.5,22.9c-6.3,6.5-13.8,9.7-22.3,9.7c-3.5,0-9-1.2-16.5-3.5c-3.5-1.2-6.1-1.9-7.8-2.3 c-2.3-0.5-3.7-0.9-4-1.3c-0.4-0.4-0.7-1.7-0.9-3.9c-0.3-2.4-1-5.8-2.3-10.3c-1.9-6.8-2.9-11.2-2.9-13.1c0-2.4,0.8-3.6,2.3-3.6 c0.7,0,1.2,0.6,1.5,1.8c2.5,8.6,6.8,15.9,12.8,21.8c6.1,5.9,12.4,8.8,19,8.8c5.1,0,9.6-1.9,13.6-5.8c4-3.9,6-8.3,6-13.4 c0-4-1-7.2-3.1-9.8c-2.1-2.6-5.7-5-10.8-7.2l-11.5-5.1c-5-2.2-9.3-4.4-12.8-6.6c-4.1-2.5-7.2-4.8-9.2-7.2 c-3.9-4.3-5.8-10-5.8-17.2c0-8.3,2.7-15.3,8.1-20.8C229.2,73.6,236,70.8,244,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.4,70.8c5.6,0,10.7,0.7,15.4,2.1c3.3,1,6.3,2.3,9.2,3.9l5,2.9c1,0.6,1.9,0.9,2.7,0.9c1,0,1.8-0.4,2.3-1.2l1.6-2.3 c0.3-0.4,0.7-0.6,1.4-0.6c1.6,0,2.3,1.6,2.3,4.9l0.1,5.5v6.9l0.6,5.7l0.7,3.4c0.3,1.7,0.5,3.1,0.5,4.5c0,1.9-0.7,2.9-2.1,2.9 c-0.8,0-1.3-0.6-1.6-1.8c-0.4-1.9-1.8-4.8-4.2-8.8c-2.4-3.9-4.7-7.1-6.8-9.4c-3.2-3.5-6.6-6.3-10.1-8.5c-6-3.8-12.4-5.7-19.2-5.7 c-9.5,0-17.2,3.9-23.2,11.7c-5.9,7.8-8.9,17.9-8.9,30.4c0,7.3,1,14,3,20c2.4,7.3,6.3,13.6,11.6,18.9c3.5,3.5,7.1,6.1,10.9,7.9 c4.1,2,8.5,3,13,3c5.1,0,10.5-1.2,16.2-3.6c5.7-2.4,10.2-5.4,13.4-9.1l4.9-5.3c0.7-0.8,1.4-1.2,2-1.3c1,0,1.4,0.5,1.4,1.7 c0,2.1-2,5.4-6,9.9c-3,3.4-6.3,6.4-9.8,8.8c-4.2,2.9-8.6,5.1-13.4,6.6c-4.8,1.5-10,2.2-15.4,2.2c-7.2,0-13.8-1.1-19.7-3.4 c-6.2-2.4-11.6-6-16.3-10.8c-4.3-4.4-7.6-9.5-9.9-15.1c-2.6-6.4-3.9-13.7-3.9-21.8c0-5.1,0.7-10.2,2-15.2 c0.8-3.1,1.9-6.1,3.2-9.1c2-4.6,4.4-8.8,7.2-12.4c2-2.6,4.2-4.9,6.6-7c4.8-4.1,9.9-7.1,15.5-9.2S337.1,70.8,343.4,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.4,152.4l0.6,7.5c0.6,3.9,2.1,6.8,4.4,8.9c2.3,2.1,5.4,3.1,9.2,3.1c2.5,0,3.7,0.8,3.7,2.3c0,1.5-1.6,2.2-4.9,2.2 c-1.4,0-3.4-0.1-6-0.4c-6.5-0.7-11.8-1.1-15.9-1.1c-5,0-9,0.3-11.9,0.8c-2.5,0.5-4.3,0.7-5.4,0.7c-1.1,0-1.8-0.5-2.1-1.6 l-0.2-0.6l2.2-1.8c3.6-1.3,6-2.9,7.2-4.8c1.2-1.9,1.8-5,1.8-9.4l0.1-6.7v-16.8v-26.3v-17c0-4.6-0.8-7.9-2.4-9.9 c-1.6-2-4.6-3.3-8.8-3.9c-2.6-0.4-4.2-0.8-4.9-1.2c-0.7-0.4-1.1-1-1.1-2c0-1.4,0.6-2.1,1.8-2.1c0.9,0.1,2.3,0.3,4.1,0.6 c1.8,0.4,4.9,0.6,9.1,0.6c2.8,0,6.3-0.2,10.5-0.5l5.5-0.4c5.2-0.4,9.2-0.6,11.9-0.6c1.7,0,2.5,0.6,2.5,1.8c0,0.9-0.1,1.5-0.4,1.8 c-0.3,0.3-0.9,0.5-1.9,0.7c-3.6,0.6-6,1.6-7,3c-1,1.4-1.5,4.3-1.5,8.6v16.3v24.3V152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.8,90.1v16.4c0,4.7,0.3,7.6,1,8.9c0.7,1.3,2.3,1.9,4.9,1.9l2.3-0.1l3.3-0.1h6.4c5,0,8.8-2.7,11.5-8.2l1.7-3.7 c0.5-0.9,1.2-1.4,2.3-1.4c1.1,0,1.7,0.6,1.7,2c0,0.4-0.1,1.5-0.2,3.3c-0.1,1.3-0.2,2.4-0.2,3.3c0,1.6,0.2,5.4,0.7,11.3 c0.3,3.9,0.5,7.3,0.5,10.1l0.1,3.9c0,0.7-0.1,1.2-0.2,1.4c-0.2,0.3-0.6,0.5-1.2,0.5c-1.3,0.1-2-0.9-2.3-2.9 c-0.7-4.3-2.2-7.5-4.5-9.7c-1.3-1.2-2.9-2-4.8-2.3c-1.9-0.4-5.4-0.5-10.6-0.5h-5.1c-2.4,0-4.1,0.4-4.9,1.1 c-0.9,0.7-1.5,2.2-1.8,4.4c-0.3,2.5-0.5,6.5-0.5,11.9v6.8c0,7.1,0.6,12.2,1.7,15.3c0.9,2.3,1.9,3.8,3,4.6 c1.2,0.8,2.9,1.2,5.4,1.2c7.3,0,13.6-0.8,19.1-2.4c5.5-1.6,10.1-3.9,13.8-7.1c3-2.5,5.4-5.6,7.2-9.2c0.4-0.6,0.7-0.9,0.9-1 c0.5-0.1,1,0.1,1.4,0.5c0.4,0.4,0.6,1,0.6,1.6c0,4.9-1.3,9.7-4,14.4c-2.2,3.9-5,6.7-8.3,8.4c-3.3,1.7-7.7,2.5-13.2,2.5 c-3.2,0-6.8-0.2-10.7-0.6l-8.8-0.8c-3.2-0.3-7.6-0.5-13.1-0.5c-3.7,0-9.3,0.2-16.8,0.7c-2.1,0.2-3.5,0.2-4.5,0.2 c-1.2,0-1.9-0.6-2-1.7c0-0.9,0.5-1.6,1.7-2.1c2.9-1.1,4.8-2.3,5.8-3.5c1-1.2,1.8-3.4,2.5-6.6c0.6-2.7,0.8-6.3,0.8-10.8v-23.8 v-19.7V91.9c0-5.6-0.9-9.4-2.8-11.5c-1.8-2-5.6-3.4-11.4-4.2c-1.4-0.2-2-0.9-2-2.2c0-1.2,0.8-1.8,2.5-1.8c0.4,0,1.1,0.1,2.3,0.2 c0.9,0.1,2.1,0.1,3.7,0.1l7.6,0.3l14.5,0.2l14.1,0.1c6.7,0,12.3,0,16.9-0.1c6.7-0.1,11.2-0.3,13.5-0.6c0.4,0,0.8-0.1,1.1-0.1 c1.5,0,2.2,0.8,2.2,2.5c0,1.2,0.2,3.2,0.5,6.2c0.4,4.4,0.6,7.5,0.6,9.4c0,3.8-1,5.8-2.9,5.9c-1,0.1-1.4-1.1-1.4-3.3 c0-5-1.8-8.6-5.5-10.9c-3.6-2.2-9.5-3.4-17.7-3.4h-9.2l-5.1,0.6c-2.6,0.8-3.8,3.3-3.8,7.6L479.8,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.8,89.8l9.1,10.2l10.8,12.1l10.4,11.7l9.6,10.8l2.6,2.9c3.4,3.8,5.7,5.7,6.9,5.7c1.1,0,1.6-1.5,1.7-4.6 c0.2-5.6,0.4-11.1,0.5-16.5c0.1-5.2,0.2-10.3,0.2-15.3c0-6.9-0.4-12.6-1.2-16.9c-0.6-3-1.4-5.4-2.3-7.1c-1.2-2.1-3-3.7-5.3-4.9 s-5.3-1.9-8.8-2.1c-1.7-0.1-2.5-0.7-2.5-1.8c0-1.3,0.7-2,2.2-2c1.8,0,4.7,0.3,8.8,0.8c2.6,0.3,4.8,0.5,6.5,0.5 c2.2,0,5.2-0.2,8.9-0.6c2.3-0.2,4.8-0.5,7.6-0.9c1-0.1,1.7-0.2,2.2-0.2c1.6,0,2.4,0.7,2.4,2.1c0,1.3-0.8,2-2.4,2.3 c-1.9,0.4-3.6,1.1-4.9,2.3c-1.5,1.3-2.7,3.2-3.5,5.6c-0.9,2.5-1.3,5.7-1.3,9.4v3.7l-0.5,22.6l-0.6,24.5l-0.3,6.5l-0.1,8.4 l0.1,5.7l0.3,9.4c0,1.4-0.5,2.1-1.5,2c-0.9-0.1-1.8-0.6-2.8-1.7l-15.1-16.8l-17.5-19.5l-15.6-17.4l-20.4-22.6c-1.2-1.3-2-2-2.5-2 c-1.2,0-1.8,1.1-1.8,3.4l-0.1,2.2v13.5v15.8c0,6.4,0.1,11.9,0.4,16.5c0.4,6.8,1,11.7,2,14.9c1.7,5.6,6.6,8.8,14.7,9.6 c1.5,0.2,2.3,0.8,2.3,1.9c0,1.5-0.8,2.3-2.3,2.3c-0.6,0-1.6-0.1-2.9-0.3c-4.2-0.7-8.9-1.1-14.1-1.1c-5.1,0-9.6,0.4-13.6,1.1 c-1.8,0.3-3.1,0.4-3.9,0.4c-1.4,0-2-0.6-2-1.8c0-1,0.7-1.7,2.2-2.2c3.7-1.1,6.4-3.2,8-6.5c1.7-3.3,2.5-8,2.5-14.2l0.5-17.9v-32.7 c0-5.8-0.8-10.6-2.4-14.3c-1.3-3-3.1-5.4-5.5-7c-2.5-1.8-5.6-2.8-9.3-3.1c-1.6-0.1-2.3-0.7-2.3-1.9c0-1.4,0.9-2.2,2.6-2.2 l5.2,0.2l3.2-0.1c3.9,0,8.1-0.2,12.6-0.7c1.7-0.2,3.1-0.2,4.2-0.2c1.6,0,2.8,0.3,3.7,1s2.8,2.8,5.7,6.2l5.2,6.1 C578.2,87.9,579.4,89.3,579.8,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.2,90.9v14v21.3v21.5c0,8.5,1.2,14.5,3.7,18.1s6.8,5.5,13.1,5.9c1.8,0.2,2.7,1,2.7,2.7c0,1.2-0.8,1.8-2.3,1.8 c-0.4,0-1,0-1.9-0.1l-5.7-0.2l-9.4-0.6c-0.8,0-1.8-0.1-3-0.1c-2.9,0-5.5,0.1-7.8,0.2l-16.7,1c-1.8,0.2-3,0.3-3.6,0.3 c-1.6,0-2.3-0.7-2.3-2c0-1.1,0.3-1.9,0.8-2.2c0.5-0.3,1.4-0.5,2.9-0.7c3.9-0.3,7-1.7,9.1-4.3c2.1-2.6,3.2-6.1,3.2-10.6l-0.1-3.5 v-15.9v-18.7v-16V86.4c0-2-0.5-3.5-1.6-4.5s-2.7-1.5-4.8-1.5c-3.9,0-7.4,0.1-10.3,0.3c-4.6,0.3-8,1-10.3,1.9 c-2.7,1.1-4.4,2.4-5.3,3.7c-0.9,1.4-2.1,4.8-3.6,10.3l-0.6,2.1c-0.6,2.1-1.4,3.1-2.6,3.1c-1.7,0-2.4-0.8-2.3-2.3 c0-1.4,0.3-3.4,0.8-5.9l0.8-6.6l0.9-6.7l0.5-4.6c0.2-2,1.3-2.9,3.2-2.9c0.5,0,1.4,0.1,2.6,0.2c2,0.2,4.8,0.2,8.4,0.2l15.4,0.2 l18.3,0.2c6.4,0,13-0.1,19.9-0.3c5.8-0.2,11.7-0.4,17.7-0.7c2.6-0.1,4.3-0.2,5.1-0.2c2.8,0,4.2,1.2,4.4,3.5l0.4,5.4 c0,0.9,0.3,2.9,0.8,6.1c0.4,2.7,0.5,4.8,0.5,6.4c0,1.7-0.7,2.5-2,2.5c-1.2,0-2-1-2.4-2.9c-0.5-2.3-1.3-4.3-2.3-6 c-1-1.7-2.3-3.1-3.8-4.2c-3-2.1-7.3-3.1-13-3.1c-2.8,0-5.2,0.1-7.2,0.2c-3.5,0.3-5.9,0.8-7.1,1.5 C712.2,83.3,711.2,86.2,711.2,90.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 217.5953 232.6356)",
    fontFamily: "'GoudyOldStyleT-Bold'",
    fontSize: "50.8017px"
  }, "ASSET MANAGEMENT")), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    d: "M112.3,8l19.3,3.8l7,2.9l6.7,1.9l8.7-3.1 l2.2,3.5l-0.2,8.5l0.2,3.8l1.4,10.3l1,9.6l0.2,2.1l-2.6,4.5l-2.7-4l-15.4-25.3l-26.1-10.7l-16.5,6.4l-7,15.1l6.2,13.9l24.9,12.3 l33,20l9.6,28.4L149,143.5l-31,13.5l-23-4.9l-10.8-3.1l-5.6-1.8l-1.3-5.4l-3.1-14.3l-4-18.3l5.4-2.5l17.9,30.3l26.4,12.3l19-8.1 l8.4-18.6l-4.4-13.6l-15.1-10l-16-7.1L81,72.6l-8.1-23.9l11.3-29L112.3,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    points: "112.3,8 131.6,11.8 138.6,14.8  145.3,16.7 154.1,13.5 156.3,17 156.1,25.5 156.3,29.3 157.6,39.5 158.7,49.1 158.9,51.2 156.3,55.7 153.6,51.7 138.2,26.4  112.1,15.7 95.6,22.1 88.6,37.1 94.8,51.1 119.7,63.3 152.7,83.3 162.3,111.6 149,143.5 118.1,157 95.1,152.1 84.3,148.9  78.6,147.1 77.3,141.7 74.2,127.4 70.2,109.1 75.6,106.6 93.4,136.9 119.8,149.1 138.8,141 147.1,122.4 142.8,108.8  127.7,98.8 111.7,91.7 81,72.6 72.9,48.7 84.2,19.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1921 -0.9814 0.9814 0.1921 82.8229 116.6965)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9235 -0.3835 0.3835 0.9235 5.4999 43.6789)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })))))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 109.1,
    x2: 75.6,
    y2: 106.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -39.8626 40.3922)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -38.2725 42.4354)",
    cx: 75.6,
    cy: 106.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 91.8,
    y1: 146.2,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -61.0831 66.0068)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -45.3778 50.1324)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 78.6,
    y1: 147.1,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.956132e-02 6.956132e-02 0.9976 -10.0414 5.8271)",
    cx: 78.6,
    cy: 147.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.955907e-02 6.955907e-02 0.9976 -9.9458 6.7365)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 118.1,
    y1: 157,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3807 -0.9247 0.9247 0.3807 -72.0727 206.4049)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3808 -0.9247 0.9247 0.3808 -78.3481 175.3658)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.8,
    y1: 149.1,
    x2: 118.1,
    y2: 157
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -51.7202 233.8399)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -60.7742 238.3055)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 119.8,
    y2: 149.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -24.6115 31.035)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -26.2286 25.5692)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.8,
    y1: 141,
    x2: 149,
    y2: 143.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -30.5266 243.4178)",
    cx: 138.8,
    cy: 141,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -25.0207 255.2617)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 147.1,
    y1: 122.4,
    x2: 162.3,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -43.7677 108.3983)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -34.6654 115.1743)",
    cx: 162.3,
    cy: 111.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -12.247 13.9206)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -10.3727 13.667)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 152.7,
    y1: 83.3,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 48.8081 222.7836)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 5.2607 250.955)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -10.3301 202.5937)",
    cx: 142.8,
    cy: 108.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 19.824 195.5237)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 127.7,
    y1: 98.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -32.8937 82.1504)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -20.9647 92.9988)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -16.0909 24.2259)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -13.5841 32.2621)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.1,73.2"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 109.1,
    y1: 73.2,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -9.2168 16.0888)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -11.7928 16.643)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -11.0967 98.4195)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -20.6361 93.8397)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -8.2817 81.7913)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -12.6618 122.4962)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 6.7567 152.0878)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 33.6575 180.7221)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 81,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 0.7432 103.4671)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 -23.7635 101.8277)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 88.6,
    y1: 37.1,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -4.7469 59.8774)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -14.6674 52.8444)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 84.2,
    y1: 19.7,
    x2: 88.6,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -2.2654 21.0115)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -6.3653 22.5898)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 95.6,
    y1: 22.1,
    x2: 84.2,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 54.4371 111.1647)",
    cx: 95.6,
    cy: 22.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 47.6967 98.1049)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.3,
    y1: 8,
    x2: 112.1,
    y2: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 101.8367 120.1343)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 94.0143 127.4699)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 131.6,
    y1: 11.8,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 6.857 55.3875)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 1.4329 59.4125)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.1,
    y1: 15.7,
    x2: 131.6,
    y2: 11.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -0.9073 22.2331)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 0.2285 25.9672)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -12.2308 62.8391)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -33.5128 89.9774)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 26.3139 161.3967)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 -6.7688 174.3845)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 157.6,
    y1: 39.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 36.5793 147.9773)",
    cx: 157.6,
    cy: 39.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 38.9201 126.0855)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 17,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 9.8406 74.1275)",
    cx: 156.3,
    cy: 17,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 3.4425 66.8391)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 154.1,
    y1: 13.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 25.9362 100.1191)",
    cx: 154.1,
    cy: 13.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 14.2673 92.9962)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.6,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 34.5216 131.4978)",
    cx: 156.3,
    cy: 29.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 39.2668 112.5572)",
    cx: 138.6,
    cy: 14.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 145.3,
    y1: 16.7,
    x2: 156.3,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 0.8918 39.8042)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 -9.2325 44.1998)",
    cx: 156.3,
    cy: 55.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 158.9,
    y1: 51.2,
    x2: 145.3,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 -7.718 61.6075)",
    cx: 158.9,
    cy: 51.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 3.9652 54.2631)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -57.8107 204.6665)",
    cx: 93.4,
    cy: 136.9,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -68.3293 210.6766)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 75.6,
    y1: 106.6,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 162.3,
    y1: 111.6,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 119.7,
    y2: 63.3
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 96.8,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 88.8,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.2,
    y1: 26.4,
    x2: 112.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.2,
    y2: 26.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_7",
    display: "none"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "test_goudy_-_copie",
    display: "none"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "subline"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "letters"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "wires"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    d: "M58,14.2l20.1,3.9l14.3,5l9.1-3.3l2.3,3.6 l-0.2,8.9l3,26.8l-2.7,4.7L85.1,33.3L57.9,22.2l-17.2,6.6l-7.3,15.7L39.8,59l44,21.3l16.4,12.3l10,29.6l-13.8,33.2l-32.3,14.1 L23,159.1l-8.8-39.6l3.4-5.3l20.8,34.2l27.5,12.8l19.8-8.5l8.7-19.4l-4.5-14.2l-15.7-10.5L38.9,91.8L25.5,81.5L17,56.6l11.8-30.2 L58,14.2L58,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    d: "M224.6,17.2L249,28.4l7.6-7.5l3.4,8.6 l-1.3,17.9l4,19.7L251.2,56l-9.9-13.6L226.2,30l-27.3-8.2l-33.6,17l-12.9,44.1l4.3,29l16.8,27.5l15.8,11.4l18.8,4.3l23.4-5.3 l19.5-13.1l10.1-9.6l-6.6,16.7l-14.2,12.8l-41.8,12.8l-28.6-4.9l-23.6-15.6l-14.4-22l-5.7-31.5l7.7-36.1l20-27.3l22.4-13.3 l25.9-4.4L224.6,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    d: "M321.9,143.4l6.4,12.9l13.3,4.5l-1.8,6.6l-8.8-0.6l-23.1-1.6l-17.3,1.1 l-7.9,1l-0.1-5.8l10.5-6.9l2.6-13.6l0.1-9.7V107V68.8V41.3l-3.5-11.4l-20.2-7.5l1.2-5.7l18.5,1.5l15.9-0.6l25.5-1.5l2.7,5.4 l-11.2,5.1L321,39.4V63v35.3L321.9,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    d: "M399.9,50.8v15l1.5,12.9l10.5,2.6l14.1-0.1 l16.7-11.9l4.8-9l4.9,4.9l-1.7,11.5l1.1,36.5l-5.1-3.4l-6.6-14.1l-6.9-3.4l-22.8-0.8l-7.2,1.6l-3.2,33.5l2.4,22.2l12.1,8.4 l27.7-3.4l19.9-10.3l14.2-12.6l0,0l-5.3,21.8L459,165l-19.2,3.7l-28.2-2.1l-18.9-0.7l-24.3,1l-9.4,0.3l2.5-5.5l8.5-5.1l3.6-9.6 l1.2-15.7V96.9V44.8l-4-16.6l-16.6-6.1l-2.2-5.8l22.6,0.8l13.8,0.2l27.7,0.2l45.6-1.1l3.2,3.6l1.5,22.7l-4.3,8.5l-10-20.6 l-25.7-4.9l-20.8,0.9L400,37.6L399.9,50.8L399.9,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    d: "M545,41.8l28.8,32.4l42.7,45.1l2.5-6.7l1-46 l-1.8-24.4l-3.4-10.3l-7.7-7.1L590.8,19l3.2-2.9l22.1,1.8l13-0.8l14.2-1.5l3.5,3.1l-10.6,6.7l-5.1,8.1l-1.9,13.7v5.4l-1.6,68.3 l-0.4,9.4l1.1,37.1l-28.8-26.8L551.4,87l-13-15.1l-21.1-24l-1.6,8.4l-0.1,45.6l0.6,23.9l2.8,21.5l24.6,16.7l-3.4,3.3l-24.7-2 l-28.2,2.2l3.1-5.8l11.7-9.4l4.4-46.6V58.4l-0.6-20.7L495,27.5L481.6,23l-3.4-2.8l3.7-3.1l12.2,0.2l18.3-1l6-0.3l5.4,1.5l8.3,9 L545,41.8L545,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    d: "M735.6,43.3v51.2v31.2l5.4,26.2l18.9,8.6l3.9,3.9l-3.4,2.6l-10.9-0.4 l-29.4-0.7l-24.2,1.4l-8.2,0.4l0.7-6.1l17.5-7.1l4.5-20.5v-23.1V83.8V60.6V36.8l-2.3-6.5l-7-2.2l-15,0.5l-14.9,2.7l-7.7,5.4 l-5.2,15l-4.6,7.6l-3.4-3.4l2.2-18.1l2.1-16.4l4.6-4.3l38.2,0.8l26.6,0.3l28.8-0.4l33-1.2l6.3,5l0.5,7.9l1.1,8.9l0.8,9.3l-3,3.6 l-3.5-4.2l-8.8-14.7L760.4,28l-20.7,2.6L735.6,43.3L735.6,43.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 153.9,
    y1: 31.9,
    x2: 165.2,
    y2: 38.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5229 -0.8524 0.8524 0.5229 46.2498 146.4291)",
    fill: "#808989",
    cx: 153.9,
    cy: 31.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5229 -0.8524 0.8524 0.5229 45.7339 159.3515)",
    fill: "#808989",
    cx: 165.2,
    cy: 38.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 176.3,
    y1: 18.6,
    x2: 165.2,
    y2: 38.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.482 -0.8762 0.8762 0.482 75.0452 164.1379)",
    fill: "#808989",
    cx: 176.3,
    cy: 18.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.482 -0.8762 0.8762 0.482 51.5686 164.8677)",
    fill: "#808989",
    cx: 165.2,
    cy: 38.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 176.3,
    y1: 18.6,
    x2: 198.8,
    y2: 21.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.142 -0.9899 0.9899 0.142 132.8794 190.5074)",
    fill: "#808989",
    cx: 176.3,
    cy: 18.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.142 -0.9899 0.9899 0.142 148.9984 215.5599)",
    fill: "#808989",
    cx: 198.8,
    cy: 21.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 202.2,
    y1: 14.2,
    x2: 198.8,
    y2: 21.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3999 -0.9165 0.9165 0.3999 108.3307 193.8132)",
    fill: "#808989",
    cx: 202.2,
    cy: 14.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3999 -0.9165 0.9165 0.3999 99.3037 195.3462)",
    fill: "#808989",
    cx: 198.8,
    cy: 21.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 14.2,
    y1: 119.6,
    x2: 34.2,
    y2: 157.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8859 -0.4639 0.4639 0.8859 -53.8417 20.215)",
    fill: "#808989",
    cx: 14.2,
    cy: 119.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8859 -0.4639 0.4639 0.8859 -69.2707 33.8437)",
    fill: "#808989",
    cx: 34.2,
    cy: 157.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 38.4,
    y1: 148.5,
    x2: 34.2,
    y2: 157.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -112.635 121.7772)",
    fill: "#808989",
    cx: 38.4,
    cy: 148.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4151 -0.9098 0.9098 0.4151 -123.5258 123.3489)",
    fill: "#808989",
    cx: 34.2,
    cy: 157.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 23,
    y1: 159.1,
    x2: 34.2,
    y2: 157.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9924 -0.1228 0.1228 0.9924 -19.3673 4.0269)",
    fill: "#808989",
    cx: 23,
    cy: 159.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9924 -0.1228 0.1228 0.9924 -19.1127 5.3895)",
    fill: "#808989",
    cx: 34.2,
    cy: 157.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 17.6,
    y1: 114.3,
    x2: 34.2,
    y2: 157.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9341 -0.357 0.357 0.9341 -39.6489 13.8025)",
    fill: "#808989",
    cx: 17.6,
    cy: 114.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9341 -0.357 0.357 0.9341 -54.0596 22.5895)",
    fill: "#808989",
    cx: 34.2,
    cy: 157.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 38.4,
    y1: 148.5,
    x2: 23,
    y2: 159.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8228 -0.5683 0.5683 0.8228 -77.5847 48.1266)",
    fill: "#808989",
    cx: 38.4,
    cy: 148.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8228 -0.5683 0.5683 0.8228 -86.3611 41.2581)",
    fill: "#808989",
    cx: 23,
    cy: 159.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 34.2,
    y1: 157.7,
    x2: 64.1,
    y2: 169.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.365 -0.931 0.931 0.365 -125.163 131.978)",
    fill: "#808989",
    cx: 34.2,
    cy: 157.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.365 -0.931 0.931 0.365 -117.084 167.2737)",
    fill: "#808989",
    cx: 64.1,
    cy: 169.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 65.9,
    y1: 161.3,
    x2: 64.1,
    y2: 169.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -105.7988 190.6986)",
    fill: "#808989",
    cx: 65.9,
    cy: 161.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -115.2376 195.3554)",
    fill: "#808989",
    cx: 64.1,
    cy: 169.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 34.2,
    y1: 157.7,
    x2: 65.9,
    y2: 161.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1102 -0.9939 0.9939 0.1102 -126.3787 174.3141)",
    fill: "#808989",
    cx: 34.2,
    cy: 157.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1102 -0.9939 0.9939 0.1102 -101.6396 208.9823)",
    fill: "#808989",
    cx: 65.9,
    cy: 161.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 96.4,
    y1: 155.3,
    x2: 65.9,
    y2: 161.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -27.8423 21.2146)",
    fill: "#808989",
    cx: 96.4,
    cy: 155.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -29.5283 15.5164)",
    fill: "#808989",
    cx: 65.9,
    cy: 161.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 94.4,
    y1: 133.4,
    x2: 96.4,
    y2: 155.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.954422e-02 8.954422e-02 0.996 -11.5688 8.988)",
    fill: "#808989",
    cx: 94.4,
    cy: 133.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.954640e-02 8.954640e-02 0.996 -13.5231 9.2527)",
    fill: "#808989",
    cx: 96.4,
    cy: 155.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 85.7,
    y1: 152.8,
    x2: 96.4,
    y2: 155.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -82.8001 200.8013)",
    fill: "#808989",
    cx: 85.7,
    cy: 152.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -77.0602 213.1472)",
    fill: "#808989",
    cx: 96.4,
    cy: 155.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 94.4,
    y1: 133.4,
    x2: 110.1,
    y2: 122.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8136 -0.5815 0.5815 0.8136 -59.9896 79.7632)",
    fill: "#808989",
    cx: 94.4,
    cy: 133.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8136 -0.5815 0.5815 0.8136 -50.5017 86.827)",
    fill: "#808989",
    cx: 110.1,
    cy: 122.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 89.8,
    y1: 119.2,
    x2: 110.1,
    y2: 122.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1424 -0.9898 0.9898 0.1424 -40.9818 191.1911)",
    fill: "#808989",
    cx: 89.8,
    cy: 119.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1424 -0.9898 0.9898 0.1424 -26.4577 213.7971)",
    fill: "#808989",
    cx: 110.1,
    cy: 122.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 100.2,
    y1: 92.6,
    x2: 89.8,
    y2: 119.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -22.3913 152.5066)",
    fill: "#808989",
    cx: 100.2,
    cy: 92.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -53.8249 159.8763)",
    fill: "#808989",
    cx: 89.8,
    cy: 119.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 94.4,
    y1: 133.4,
    x2: 100.2,
    y2: 92.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 -50.9677 208.1592)",
    fill: "#808989",
    cx: 94.4,
    cy: 133.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 -5.5714 178.7935)",
    fill: "#808989",
    cx: 100.2,
    cy: 92.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 89.5,
    x2: 74.1,
    y2: 108.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2005 0.2005 0.9797 -16.5191 15.8864)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2005 0.2005 0.9797 -20.3031 17.0684)",
    fill: "#808989",
    cx: 74.1,
    cy: 108.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 83.8,
    y1: 80.3,
    x2: 70.2,
    y2: 89.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8288 -0.5595 0.5595 0.8288 -30.5679 60.6439)",
    fill: "#808989",
    cx: 83.8,
    cy: 80.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8288 -0.5595 0.5595 0.8288 -38.063 54.5818)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 39.8,
    y1: 59,
    x2: 70.2,
    y2: 89.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7084 -0.7059 0.7059 0.7084 -30.0465 45.2946)",
    fill: "#808989",
    cx: 39.8,
    cy: 59,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7084 -0.7059 0.7059 0.7084 -42.7068 75.6308)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 38.9,
    y1: 91.8,
    x2: 70.2,
    y2: 89.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9972 -7.433286e-02 7.433286e-02 0.9972 -6.7186 3.142)",
    fill: "#808989",
    cx: 38.9,
    cy: 91.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9972 -7.433346e-02 7.433346e-02 0.9972 -6.4585 5.4636)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 39.8,
    y1: 59,
    x2: 38.9,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.854434e-02 -0.9996 0.9996 2.854434e-02 -20.3299 97.0966)",
    fill: "#808989",
    cx: 39.8,
    cy: 59,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.854434e-02 -0.9996 0.9996 2.854434e-02 -54.0504 128.0461)",
    fill: "#808989",
    cx: 38.9,
    cy: 91.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 25.5,
    y1: 81.5,
    x2: 39.8,
    y2: 59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.538 -0.8429 0.8429 0.538 -56.9055 59.09)",
    fill: "#808989",
    cx: 25.5,
    cy: 81.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.538 -0.8429 0.8429 0.538 -31.3576 60.7984)",
    fill: "#808989",
    cx: 39.8,
    cy: 59,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 17,
    y1: 56.6,
    x2: 39.8,
    y2: 59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1073 -0.9942 0.9942 0.1073 -41.0318 67.4042)",
    fill: "#808989",
    cx: 17,
    cy: 56.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1073 -0.9942 0.9942 0.1073 -23.1461 92.2375)",
    fill: "#808989",
    cx: 39.8,
    cy: 59,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 33.3,
    y1: 44.5,
    x2: 17,
    y2: 56.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -19.9234 28.5005)",
    fill: "#808989",
    cx: 33.3,
    cy: 44.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -30.2653 21.1689)",
    fill: "#808989",
    cx: 17,
    cy: 56.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 28.8,
    y1: 26.3,
    x2: 33.3,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -5.5258 7.7654)",
    fill: "#808989",
    cx: 28.8,
    cy: 26.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -9.7995 9.4105)",
    fill: "#808989",
    cx: 33.3,
    cy: 44.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 89.5,
    x2: 100.2,
    y2: 92.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.103 -0.9947 0.9947 0.103 -26.0806 150.071)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.103 -0.9947 0.9947 0.103 -2.2587 182.7056)",
    fill: "#808989",
    cx: 100.2,
    cy: 92.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 89.8,
    y1: 119.2,
    x2: 70.2,
    y2: 89.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8341 -0.5516 0.5516 0.8341 -50.8697 69.3326)",
    fill: "#808989",
    cx: 89.8,
    cy: 119.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8341 -0.5516 0.5516 0.8341 -37.7241 53.548)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 110.1,
    y1: 122.2,
    x2: 70.2,
    y2: 89.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6328 -0.7743 0.7743 0.6328 -54.1487 130.1536)",
    fill: "#808989",
    cx: 110.1,
    cy: 122.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6328 -0.7743 0.7743 0.6328 -43.532 87.2)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 25.5,
    y1: 81.5,
    x2: 70.2,
    y2: 89.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1769 -0.9842 0.9842 0.1769 -59.223 92.1097)",
    fill: "#808989",
    cx: 25.5,
    cy: 81.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1769 -0.9842 0.9842 0.1769 -30.3258 142.7322)",
    fill: "#808989",
    cx: 70.2,
    cy: 89.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 40.7,
    y1: 28.8,
    x2: 28.8,
    y2: 26.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 4.1485 62.7282)",
    fill: "#808989",
    cx: 40.7,
    cy: 28.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 -2.8778 49.1145)",
    fill: "#808989",
    cx: 28.8,
    cy: 26.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 58,
    y1: 14.2,
    x2: 57.9,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.135470e-02 -0.9998 0.9998 2.135470e-02 42.6387 71.9056)",
    fill: "#808989",
    cx: 58,
    cy: 14.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.135481e-02 -0.9998 0.9998 2.135481e-02 34.4844 79.5534)",
    fill: "#808989",
    cx: 57.9,
    cy: 22.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 85.1,
    y1: 33.3,
    x2: 83.9,
    y2: 24.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9906 -0.137 0.137 0.9906 -3.7586 11.964)",
    fill: "#808989",
    cx: 85.1,
    cy: 33.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9906 -0.137 0.137 0.9906 -2.6059 11.723)",
    fill: "#808989",
    cx: 83.9,
    cy: 24.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 78.2,
    y1: 18.1,
    x2: 83.9,
    y2: 24.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7605 -0.6493 0.6493 0.7605 6.9627 55.103)",
    fill: "#808989",
    cx: 78.2,
    cy: 18.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7605 -0.6493 0.6493 0.7605 3.9887 60.4107)",
    fill: "#808989",
    cx: 83.9,
    cy: 24.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 57.9,
    y1: 22.2,
    x2: 83.9,
    y2: 24.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1008 -0.9949 0.9949 0.1008 29.9924 77.5103)",
    fill: "#808989",
    cx: 57.9,
    cy: 22.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1008 -0.9949 0.9949 0.1008 50.7571 105.7578)",
    fill: "#808989",
    cx: 83.9,
    cy: 24.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 78.2,
    y1: 18.1,
    x2: 57.9,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -2.0328 15.6424)",
    fill: "#808989",
    cx: 78.2,
    cy: 18.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -3.2171 11.7495)",
    fill: "#808989",
    cx: 57.9,
    cy: 22.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 28.8,
    y1: 26.3,
    x2: 57.9,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9899 -0.1417 0.1417 0.9899 -3.4404 4.3439)",
    fill: "#808989",
    cx: 28.8,
    cy: 26.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9899 -0.1417 0.1417 0.9899 -2.5565 8.4254)",
    fill: "#808989",
    cx: 57.9,
    cy: 22.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 40.7,
    y1: 28.8,
    x2: 58,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7649 -0.6442 0.6442 0.7649 -8.9976 32.9735)",
    fill: "#808989",
    cx: 40.7,
    cy: 28.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7649 -0.6442 0.6442 0.7649 4.5194 40.7276)",
    fill: "#808989",
    cx: 58,
    cy: 14.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 17,
    y1: 56.6,
    x2: 40.7,
    y2: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6488 -0.761 0.761 0.6488 -37.0563 32.8114)",
    fill: "#808989",
    cx: 17,
    cy: 56.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6488 -0.761 0.761 0.6488 -7.6417 41.066)",
    fill: "#808989",
    cx: 40.7,
    cy: 28.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 58,
    y1: 14.2,
    x2: 85.1,
    y2: 33.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5778 -0.8162 0.8162 0.5778 12.9422 53.3641)",
    fill: "#808989",
    cx: 58,
    cy: 14.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5778 -0.8162 0.8162 0.5778 8.7412 83.4872)",
    fill: "#808989",
    cx: 85.1,
    cy: 33.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 106.6,
    y1: 59.2,
    x2: 85.1,
    y2: 33.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7677 -0.6409 0.6409 0.7677 -13.129 82.0879)",
    fill: "#808989",
    cx: 106.6,
    cy: 59.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7677 -0.6409 0.6409 0.7677 -1.5742 62.2481)",
    fill: "#808989",
    cx: 85.1,
    cy: 33.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 103.9,
    y1: 23.5,
    x2: 85.1,
    y2: 33.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.4621 0.4621 0.8869 0.9105 50.6682)",
    fill: "#808989",
    cx: 103.9,
    cy: 23.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.4621 0.4621 0.8869 -5.7596 43.0702)",
    fill: "#808989",
    cx: 85.1,
    cy: 33.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 99.2,
    y1: 43.8,
    x2: 103.7,
    y2: 32.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3653 -0.9309 0.9309 0.3653 22.2133 120.1279)",
    fill: "#808989",
    cx: 99.2,
    cy: 43.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3653 -0.9309 0.9309 0.3653 35.7043 117.0487)",
    fill: "#808989",
    cx: 103.7,
    cy: 32.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 103.9,
    y1: 63.9,
    x2: 99.2,
    y2: 43.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9736 -0.2281 0.2281 0.9736 -11.8282 25.3901)",
    fill: "#808989",
    cx: 103.9,
    cy: 63.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9736 -0.2281 0.2281 0.9736 -7.3702 23.7867)",
    fill: "#808989",
    cx: 99.2,
    cy: 43.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 83.9,
    y1: 24.8,
    x2: 99.2,
    y2: 43.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7781 -0.6281 0.6281 0.7781 3.0369 58.1936)",
    fill: "#808989",
    cx: 83.9,
    cy: 24.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7781 -0.6281 0.6281 0.7781 -5.4831 72.0248)",
    fill: "#808989",
    cx: 99.2,
    cy: 43.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 92.5,
    y1: 23.1,
    x2: 99.2,
    y2: 43.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9512 -0.3086 0.3086 0.9512 -2.6278 29.6806)",
    fill: "#808989",
    cx: 92.5,
    cy: 23.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9512 -0.3086 0.3086 0.9512 -8.6667 32.7527)",
    fill: "#808989",
    cx: 99.2,
    cy: 43.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 99.2,
    y1: 43.8,
    x2: 101.6,
    y2: 19.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1001 -0.995 0.995 0.1001 45.7254 138.1007)",
    fill: "#808989",
    cx: 99.2,
    cy: 43.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1001 -0.995 0.995 0.1001 71.6786 118.9756)",
    fill: "#808989",
    cx: 101.6,
    cy: 19.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 85.1,
    y1: 33.3,
    x2: 99.2,
    y2: 43.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 7.671 81.8209)",
    fill: "#808989",
    cx: 85.1,
    cy: 33.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 4.975 97.4247)",
    fill: "#808989",
    cx: 99.2,
    cy: 43.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 106.6,
    y1: 59.2,
    x2: 99.2,
    y2: 43.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9001 -0.4356 0.4356 0.9001 -15.1166 52.3663)",
    fill: "#808989",
    cx: 106.6,
    cy: 59.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9001 -0.4356 0.4356 0.9001 -9.161 47.5884)",
    fill: "#808989",
    cx: 99.2,
    cy: 43.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 140.7,
    y1: 94.7,
    x2: 152.3,
    y2: 82.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7013 -0.7128 0.7128 0.7013 -25.4935 128.5626)",
    fill: "#808989",
    cx: 140.7,
    cy: 94.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7013 -0.7128 0.7128 0.7013 -13.6182 133.3122)",
    fill: "#808989",
    cx: 152.3,
    cy: 82.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 156.6,
    y1: 111.9,
    x2: 131.9,
    y2: 126.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8544 -0.5196 0.5196 0.8544 -35.3595 97.6649)",
    fill: "#808989",
    cx: 156.6,
    cy: 111.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8544 -0.5196 0.5196 0.8544 -46.7453 87.034)",
    fill: "#808989",
    cx: 131.9,
    cy: 126.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 146.3,
    y1: 148.9,
    x2: 140.7,
    y2: 94.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9946 -0.1036 0.1036 0.9946 -14.6339 15.9552)",
    fill: "#808989",
    cx: 146.3,
    cy: 148.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9946 -0.1036 0.1036 0.9946 -9.0522 15.0793)",
    fill: "#808989",
    cx: 140.7,
    cy: 94.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M140.7,94.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 126.2,
    y1: 95.4,
    x2: 156.6,
    y2: 111.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4788 -0.8779 0.8779 0.4788 -17.9362 160.5388)",
    fill: "#808989",
    cx: 126.2,
    cy: 95.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4788 -0.8779 0.8779 0.4788 -16.6484 195.8039)",
    fill: "#808989",
    cx: 156.6,
    cy: 111.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M140.7,94.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 133.9,
    y1: 59.2,
    x2: 152.3,
    y2: 82.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7905 -0.6124 0.6124 0.7905 -8.2231 94.4467)",
    fill: "#808989",
    cx: 133.9,
    cy: 59.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7905 -0.6124 0.6124 0.7905 -18.8753 110.6325)",
    fill: "#808989",
    cx: 152.3,
    cy: 82.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M165.2,38.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M140.7,94.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M153.9,31.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 169.9,
    y1: 164.5,
    x2: 156.6,
    y2: 111.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9692 -0.2463 0.2463 0.9692 -35.2839 46.9209)",
    fill: "#808989",
    cx: 169.9,
    cy: 164.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9692 -0.2463 0.2463 0.9692 -22.7411 42.0088)",
    fill: "#808989",
    cx: 156.6,
    cy: 111.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 173.4,
    y1: 139.4,
    x2: 146.3,
    y2: 148.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9438 -0.3306 0.3306 0.9438 -36.3308 65.1685)",
    fill: "#808989",
    cx: 173.4,
    cy: 139.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9438 -0.3306 0.3306 0.9438 -40.9939 56.7413)",
    fill: "#808989",
    cx: 146.3,
    cy: 148.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 169.9,
    y1: 164.5,
    x2: 173.4,
    y2: 139.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1371 -0.9906 0.9906 0.1371 -16.3263 310.3072)",
    fill: "#808989",
    cx: 169.9,
    cy: 164.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1371 -0.9906 0.9906 0.1371 11.569 292.0684)",
    fill: "#808989",
    cx: 173.4,
    cy: 139.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 131.9,
    y1: 126.9,
    x2: 173.4,
    y2: 139.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2878 -0.9577 0.9577 0.2878 -27.5964 216.7383)",
    fill: "#808989",
    cx: 131.9,
    cy: 126.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2878 -0.9577 0.9577 0.2878 -9.9776 265.3716)",
    fill: "#808989",
    cx: 173.4,
    cy: 139.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 140.7,
    y1: 94.7,
    x2: 131.9,
    y2: 126.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2623 -0.965 0.965 0.2623 12.3916 205.6174)",
    fill: "#808989",
    cx: 140.7,
    cy: 94.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2623 -0.965 0.965 0.2623 -25.1588 220.9364)",
    fill: "#808989",
    cx: 131.9,
    cy: 126.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 126.2,
    y1: 95.4,
    x2: 165.2,
    y2: 38.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5675 -0.8234 0.8234 0.5675 -23.9294 145.1978)",
    fill: "#808989",
    cx: 126.2,
    cy: 95.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5675 -0.8234 0.8234 0.5675 39.4931 152.827)",
    fill: "#808989",
    cx: 165.2,
    cy: 38.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 226.2,
    y1: 30,
    x2: 202.2,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.552 -0.8338 0.8338 0.552 76.2551 202.0243)",
    fill: "#808989",
    cx: 226.2,
    cy: 30,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.552 -0.8338 0.8338 0.552 78.7501 174.9312)",
    fill: "#808989",
    cx: 202.2,
    cy: 14.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 224.6,
    y1: 17.2,
    x2: 198.8,
    y2: 21.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9844 -0.1758 0.1758 0.9844 0.4668 39.7486)",
    fill: "#808989",
    cx: 224.6,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9844 -0.1758 0.1758 0.9844 -0.7415 35.2976)",
    fill: "#808989",
    cx: 198.8,
    cy: 21.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 226.2,
    y1: 30,
    x2: 224.6,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9924 -0.123 0.123 0.9924 -1.9778 28.0361)",
    fill: "#808989",
    cx: 226.2,
    cy: 30,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9924 -0.123 0.123 0.9924 -0.4157 27.7438)",
    fill: "#808989",
    cx: 224.6,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M262.6,67.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M249,28.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M241.2,42.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M226.2,30"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M260,29.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M224.6,17.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M256.6,20.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 258.6,
    y1: 47.4,
    x2: 241.2,
    y2: 42.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2804 -0.9599 0.9599 0.2804 140.5664 282.3895)",
    fill: "#808989",
    cx: 258.6,
    cy: 47.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2804 -0.9599 0.9599 0.2804 132.9277 262.0402)",
    fill: "#808989",
    cx: 241.2,
    cy: 42.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 224.6,
    y1: 17.2,
    x2: 241.2,
    y2: 42.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8332 -0.5529 0.5529 0.8332 27.9195 127.0447)",
    fill: "#808989",
    cx: 224.6,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8332 -0.5529 0.5529 0.8332 16.8092 140.4533)",
    fill: "#808989",
    cx: 241.2,
    cy: 42.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 165.2,
    y1: 38.8,
    x2: 133.9,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8372 -0.5469 0.5469 0.8372 5.6622 96.6692)",
    fill: "#808989",
    cx: 165.2,
    cy: 38.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8372 -0.5469 0.5469 0.8372 -10.5939 82.8979)",
    fill: "#808989",
    cx: 133.9,
    cy: 59.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 140.7,
    y1: 94.7,
    x2: 133.9,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9825 -0.1864 0.1864 0.9825 -15.1861 27.8786)",
    fill: "#808989",
    cx: 140.7,
    cy: 94.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9825 -0.1864 0.1864 0.9825 -8.6948 26.0033)",
    fill: "#808989",
    cx: 133.9,
    cy: 59.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 140.7,
    y1: 94.7,
    x2: 133.9,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9825 -0.1864 0.1864 0.9825 -15.1861 27.8786)",
    fill: "#808989",
    cx: 140.7,
    cy: 94.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9825 -0.1864 0.1864 0.9825 -8.6948 26.0033)",
    fill: "#808989",
    cx: 133.9,
    cy: 59.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 165.2,
    y1: 38.8,
    x2: 133.9,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8372 -0.5469 0.5469 0.8372 5.6622 96.6692)",
    fill: "#808989",
    cx: 165.2,
    cy: 38.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8372 -0.5469 0.5469 0.8372 -10.5939 82.8979)",
    fill: "#808989",
    cx: 133.9,
    cy: 59.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 249,
    y1: 28.4,
    x2: 251.2,
    y2: 56
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.997 -7.700636e-02 7.700636e-02 0.997 -1.4475 19.2606)",
    fill: "#808989",
    cx: 249,
    cy: 28.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.997 -7.700666e-02 7.700666e-02 0.997 -3.5633 19.5064)",
    fill: "#808989",
    cx: 251.2,
    cy: 56,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 262.6,
    y1: 67.1,
    x2: 251.2,
    y2: 56
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6989 -0.7152 0.7152 0.6989 31.0393 208.0156)",
    fill: "#808989",
    cx: 262.6,
    cy: 67.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6989 -0.7152 0.7152 0.6989 35.5917 196.4642)",
    fill: "#808989",
    cx: 251.2,
    cy: 56,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 260,
    y1: 29.5,
    x2: 241.2,
    y2: 42.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8242 -0.5662 0.5662 0.8242 28.9893 152.3846)",
    fill: "#808989",
    cx: 260,
    cy: 29.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8242 -0.5662 0.5662 0.8242 18.4116 144.0409)",
    fill: "#808989",
    cx: 241.2,
    cy: 42.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 241.2,
    y1: 42.4,
    x2: 249,
    y2: 28.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.487 -0.8734 0.8734 0.487 86.7485 232.4221)",
    fill: "#808989",
    cx: 241.2,
    cy: 42.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.487 -0.8734 0.8734 0.487 102.9368 232.0599)",
    fill: "#808989",
    cx: 249,
    cy: 28.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 256.6,
    y1: 20.9,
    x2: 251.2,
    y2: 56
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.153 -0.9882 0.9882 0.153 196.6231 271.2795)",
    fill: "#808989",
    cx: 256.6,
    cy: 20.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.153 -0.9882 0.9882 0.153 157.4149 295.5847)",
    fill: "#808989",
    cx: 251.2,
    cy: 56,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 260,
    y1: 29.5,
    x2: 249,
    y2: 28.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.951863e-02 -0.995 0.995 9.951863e-02 204.7474 285.2353)",
    fill: "#808989",
    cx: 260,
    cy: 29.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.951385e-02 -0.995 0.995 9.951385e-02 195.9819 273.3589)",
    fill: "#808989",
    cx: 249,
    cy: 28.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 169.9,
    y1: 164.5,
    x2: 208,
    y2: 155.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9709 -0.2395 0.2395 0.9709 -34.4577 45.4907)",
    fill: "#808989",
    cx: 169.9,
    cy: 164.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9709 -0.2395 0.2395 0.9709 -31.0983 54.3413)",
    fill: "#808989",
    cx: 208,
    cy: 155.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 198.6,
    y1: 169.5,
    x2: 208,
    y2: 155.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5511 -0.8344 0.8344 0.5511 -52.2713 241.7575)",
    fill: "#808989",
    cx: 198.6,
    cy: 169.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5511 -0.8344 0.8344 0.5511 -36.0578 243.2241)",
    fill: "#808989",
    cx: 208,
    cy: 155.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 240.3,
    y1: 156.6,
    x2: 208,
    y2: 155.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.682163e-02 -0.9989 0.9989 4.682163e-02 72.6177 389.3832)",
    fill: "#808989",
    cx: 240.3,
    cy: 156.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.682186e-02 -0.9989 0.9989 4.682186e-02 43.3447 355.678)",
    fill: "#808989",
    cx: 208,
    cy: 155.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 231.5,
    y1: 149.8,
    x2: 240.3,
    y2: 156.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6091 -0.7931 0.7931 0.6091 -28.3531 242.1499)",
    fill: "#808989",
    cx: 231.5,
    cy: 149.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6091 -0.7931 0.7931 0.6091 -30.286 251.8316)",
    fill: "#808989",
    cx: 240.3,
    cy: 156.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 251,
    y1: 136.7,
    x2: 254.5,
    y2: 143.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8977 -0.4405 0.4405 0.8977 -34.5559 124.5424)",
    fill: "#808989",
    cx: 251,
    cy: 136.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8977 -0.4405 0.4405 0.8977 -37.3468 126.8191)",
    fill: "#808989",
    cx: 254.5,
    cy: 143.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 261.1,
    y1: 127.1,
    x2: 254.5,
    y2: 143.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3651 -0.931 0.931 0.3651 47.406 323.738)",
    fill: "#808989",
    cx: 261.1,
    cy: 127.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3651 -0.931 0.931 0.3651 27.6501 328.2544)",
    fill: "#808989",
    cx: 254.5,
    cy: 143.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 240.3,
    y1: 156.6,
    x2: 251,
    y2: 136.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4711 -0.8821 0.8821 0.4711 -11.0479 294.8575)",
    fill: "#808989",
    cx: 240.3,
    cy: 156.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4711 -0.8821 0.8821 0.4711 12.1693 293.7037)",
    fill: "#808989",
    cx: 251,
    cy: 136.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 189.2,
    y1: 150.8,
    x2: 198.6,
    y2: 169.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8942 -0.4477 0.4477 0.8942 -47.5026 100.6855)",
    fill: "#808989",
    cx: 189.2,
    cy: 150.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8942 -0.4477 0.4477 0.8942 -54.8568 106.8333)",
    fill: "#808989",
    cx: 198.6,
    cy: 169.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 341.6,
    y1: 160.8,
    x2: 339.9,
    y2: 167.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2576 -0.9662 0.9662 0.2576 98.2147 449.4666)",
    fill: "#808989",
    cx: 341.6,
    cy: 160.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2576 -0.9662 0.9662 0.2576 90.5696 452.6475)",
    fill: "#808989",
    cx: 339.9,
    cy: 167.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 328.3,
    y1: 156.3,
    x2: 339.9,
    y2: 167.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6914 -0.7224 0.7224 0.6914 -11.6357 285.4249)",
    fill: "#808989",
    cx: 328.3,
    cy: 156.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6914 -0.7224 0.7224 0.6914 -16.0565 297.1745)",
    fill: "#808989",
    cx: 339.9,
    cy: 167.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 331.1,
    y1: 166.8,
    x2: 328.3,
    y2: 156.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9663 -0.2574 0.2574 0.9663 -31.7788 90.8411)",
    fill: "#808989",
    cx: 331.1,
    cy: 166.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9663 -0.2574 0.2574 0.9663 -29.177 89.7701)",
    fill: "#808989",
    cx: 328.3,
    cy: 156.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.8,
    y1: 141,
    x2: 331.1,
    y2: 166.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.589 -0.8081 0.8081 0.589 7.5682 296.9662)",
    fill: "#808989",
    cx: 295.8,
    cy: 141,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.589 -0.8081 0.8081 0.589 1.2722 336.1161)",
    fill: "#808989",
    cx: 331.1,
    cy: 166.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 282.8,
    y1: 167.4,
    x2: 282.7,
    y2: 161.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9998 -1.891997e-02 1.891997e-02 0.9998 -3.1163 5.3813)",
    fill: "#808989",
    cx: 282.8,
    cy: 167.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9998 -1.891514e-02 1.891514e-02 0.9998 -3.0058 5.3768)",
    fill: "#808989",
    cx: 282.7,
    cy: 161.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 290.7,
    y1: 166.3,
    x2: 282.7,
    y2: 161.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5117 -0.8592 0.8592 0.5117 -0.9587 330.9957)",
    fill: "#808989",
    cx: 290.7,
    cy: 166.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5117 -0.8592 0.8592 0.5117 -0.7703 321.8108)",
    fill: "#808989",
    cx: 282.7,
    cy: 161.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 293.2,
    y1: 154.6,
    x2: 290.7,
    y2: 166.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.206 -0.9786 0.9786 0.206 81.4527 409.6797)",
    fill: "#808989",
    cx: 293.2,
    cy: 154.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.206 -0.9786 0.9786 0.206 68.0551 416.5564)",
    fill: "#808989",
    cx: 290.7,
    cy: 166.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 308,
    y1: 165.2,
    x2: 293.2,
    y2: 154.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5796 -0.8149 0.8149 0.5796 -5.1384 320.4304)",
    fill: "#808989",
    cx: 308,
    cy: 165.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5796 -0.8149 0.8149 0.5796 -2.7756 303.9134)",
    fill: "#808989",
    cx: 293.2,
    cy: 154.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 321.9,
    y1: 143.4,
    x2: 308,
    y2: 165.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5382 -0.8428 0.8428 0.5382 27.773 337.5493)",
    fill: "#808989",
    cx: 321.9,
    cy: 143.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5382 -0.8428 0.8428 0.5382 3.0113 335.887)",
    fill: "#808989",
    cx: 308,
    cy: 165.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 293.2,
    y1: 154.6,
    x2: 331.1,
    y2: 166.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3054 -0.9522 0.9522 0.3054 56.3919 386.5986)",
    fill: "#808989",
    cx: 293.2,
    cy: 154.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3054 -0.9522 0.9522 0.3054 71.1526 431.1537)",
    fill: "#808989",
    cx: 331.1,
    cy: 166.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.9,
    y1: 131.3,
    x2: 321.9,
    y2: 143.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4217 -0.9067 0.9067 0.4217 52.0241 344.2067)",
    fill: "#808989",
    cx: 295.9,
    cy: 131.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4217 -0.9067 0.9067 0.4217 56.1021 374.8279)",
    fill: "#808989",
    cx: 321.9,
    cy: 143.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.9,
    y1: 107,
    x2: 321.9,
    y2: 143.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8133 -0.5818 0.5818 0.8133 -7.0373 192.1056)",
    fill: "#808989",
    cx: 295.9,
    cy: 107,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8133 -0.5818 0.5818 0.8133 -23.3596 214.0544)",
    fill: "#808989",
    cx: 321.9,
    cy: 143.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 321,
    y1: 98.3,
    x2: 295.9,
    y2: 107
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9451 -0.3267 0.3267 0.9451 -14.5056 110.2709)",
    fill: "#808989",
    cx: 321,
    cy: 98.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9451 -0.3267 0.3267 0.9451 -18.7288 102.5253)",
    fill: "#808989",
    cx: 295.9,
    cy: 107,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.9,
    y1: 68.8,
    x2: 321.9,
    y2: 143.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9441 -0.3296 0.3296 0.9441 -6.1539 101.3718)",
    fill: "#808989",
    cx: 295.9,
    cy: 68.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9441 -0.3296 0.3296 0.9441 -29.288 114.1275)",
    fill: "#808989",
    cx: 321.9,
    cy: 143.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 321,
    y1: 63,
    x2: 295.9,
    y2: 68.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9745 -0.2246 0.2246 0.9745 -5.9556 73.7)",
    fill: "#808989",
    cx: 321,
    cy: 63,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9745 -0.2246 0.2246 0.9745 -7.901 68.1959)",
    fill: "#808989",
    cx: 295.9,
    cy: 68.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 292.4,
    y1: 29.9,
    x2: 321,
    y2: 63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7559 -0.6546 0.6546 0.7559 51.7622 198.6908)",
    fill: "#808989",
    cx: 292.4,
    cy: 29.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7559 -0.6546 0.6546 0.7559 37.0862 225.5428)",
    fill: "#808989",
    cx: 321,
    cy: 63,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.9,
    y1: 41.3,
    x2: 321,
    y2: 63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6529 -0.7574 0.7574 0.6529 71.3777 238.4385)",
    fill: "#808989",
    cx: 295.9,
    cy: 41.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6529 -0.7574 0.7574 0.6529 63.6794 265.0337)",
    fill: "#808989",
    cx: 321,
    cy: 63,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 321,
    y1: 39.4,
    x2: 295.9,
    y2: 41.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9972 -7.511976e-02 7.511976e-02 0.9972 -2.0556 24.2273)",
    fill: "#808989",
    cx: 321,
    cy: 39.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9972 -7.511976e-02 7.511976e-02 0.9972 -2.2691 22.3419)",
    fill: "#808989",
    cx: 295.9,
    cy: 41.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 307.8,
    y1: 17.7,
    x2: 292.4,
    y2: 29.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7841 -0.6206 0.6206 0.7841 55.4501 194.8355)",
    fill: "#808989",
    cx: 307.8,
    cy: 17.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7841 -0.6206 0.6206 0.7841 44.5406 187.8959)",
    fill: "#808989",
    cx: 292.4,
    cy: 29.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 321,
    y1: 39.4,
    x2: 307.8,
    y2: 17.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8539 -0.5204 0.5204 0.8539 26.3756 172.8353)",
    fill: "#808989",
    cx: 321,
    cy: 39.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8539 -0.5204 0.5204 0.8539 35.7486 162.7695)",
    fill: "#808989",
    cx: 307.8,
    cy: 17.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.9,
    y1: 41.3,
    x2: 321.9,
    y2: 143.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.969 -0.2472 0.2472 0.969 -1.0361 74.4172)",
    fill: "#808989",
    cx: 295.9,
    cy: 41.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.969 -0.2472 0.2472 0.969 -25.465 84.0231)",
    fill: "#808989",
    cx: 321.9,
    cy: 143.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 321,
    y1: 39.4,
    x2: 291.9,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5874 -0.8093 0.8093 0.5874 100.543 276.0856)",
    fill: "#808989",
    cx: 321,
    cy: 39.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5874 -0.8093 0.8093 0.5874 105.6305 243.8234)",
    fill: "#808989",
    cx: 291.9,
    cy: 18.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 272.2,
    y1: 22.5,
    x2: 291.9,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9788 -0.205 0.205 0.9788 1.1764 56.2651)",
    fill: "#808989",
    cx: 272.2,
    cy: 22.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9788 -0.205 0.205 0.9788 2.4429 60.2239)",
    fill: "#808989",
    cx: 291.9,
    cy: 18.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 273.4,
    y1: 16.8,
    x2: 292.4,
    y2: 29.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5695 -0.822 0.822 0.5695 103.8968 231.9552)",
    fill: "#808989",
    cx: 273.4,
    cy: 16.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5695 -0.822 0.822 0.5695 101.2608 253.1964)",
    fill: "#808989",
    cx: 292.4,
    cy: 29.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 333.3,
    y1: 16.2,
    x2: 295.9,
    y2: 41.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8307 -0.5567 0.5567 0.8307 47.3961 188.3114)",
    fill: "#808989",
    cx: 333.3,
    cy: 16.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8307 -0.5567 0.5567 0.8307 27.0729 171.7014)",
    fill: "#808989",
    cx: 295.9,
    cy: 41.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 307.8,
    y1: 17.7,
    x2: 295.9,
    y2: 41.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4507 -0.8927 0.8927 0.4507 153.2533 284.4824)",
    fill: "#808989",
    cx: 307.8,
    cy: 17.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4507 -0.8927 0.8927 0.4507 125.6123 286.8101)",
    fill: "#808989",
    cx: 295.9,
    cy: 41.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 324.9,
    y1: 26.7,
    x2: 307.8,
    y2: 17.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.467 -0.8843 0.8843 0.467 149.5227 301.5505)",
    fill: "#808989",
    cx: 324.9,
    cy: 26.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.467 -0.8843 0.8843 0.467 148.3933 281.6074)",
    fill: "#808989",
    cx: 307.8,
    cy: 17.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 336.1,
    y1: 21.6,
    x2: 307.8,
    y2: 17.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1379 -0.9904 0.9904 0.1379 268.2852 351.5247)",
    fill: "#808989",
    cx: 336.1,
    cy: 21.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1379 -0.9904 0.9904 0.1379 247.8036 320.1184)",
    fill: "#808989",
    cx: 307.8,
    cy: 17.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.9,
    y1: 68.8,
    x2: 321,
    y2: 98.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7606 -0.6492 0.6492 0.7606 26.1456 208.5666)",
    fill: "#808989",
    cx: 295.9,
    cy: 68.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7606 -0.6492 0.6492 0.7606 13.0279 231.9678)",
    fill: "#808989",
    cx: 321,
    cy: 98.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 295.9,
    y1: 107,
    x2: 321,
    y2: 63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4967 -0.8679 0.8679 0.4967 56.0325 310.6602)",
    fill: "#808989",
    cx: 295.9,
    cy: 107,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4967 -0.8679 0.8679 0.4967 106.8801 310.366)",
    fill: "#808989",
    cx: 321,
    cy: 63,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 471.1,
    y1: 152.8,
    x2: 442.2,
    y2: 153.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9993 -3.838135e-02 3.838135e-02 0.9993 -5.517 18.1928)",
    fill: "#808989",
    cx: 471.1,
    cy: 152.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9993 -3.839082e-02 3.839082e-02 0.9993 -5.5821 17.0905)",
    fill: "#808989",
    cx: 442.2,
    cy: 153.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 439.9,
    y1: 168.7,
    x2: 442.2,
    y2: 153.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.156 -0.9878 0.9878 0.156 204.6317 576.8779)",
    fill: "#808989",
    cx: 439.9,
    cy: 168.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.156 -0.9878 0.9878 0.156 221.2283 566.6919)",
    fill: "#808989",
    cx: 442.2,
    cy: 153.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 442.2,
    y1: 153.9,
    x2: 411.6,
    y2: 166.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9232 -0.3842 0.3842 0.9232 -25.1842 181.7345)",
    fill: "#808989",
    cx: 442.2,
    cy: 153.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9232 -0.3842 0.3842 0.9232 -32.4205 170.964)",
    fill: "#808989",
    cx: 411.6,
    cy: 166.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 442.2,
    y1: 153.9,
    x2: 459,
    y2: 165
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5519 -0.8339 0.8339 0.5519 69.8323 437.7392)",
    fill: "#808989",
    cx: 442.2,
    cy: 153.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5519 -0.8339 0.8339 0.5519 68.0903 456.75)",
    fill: "#808989",
    cx: 459,
    cy: 165,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 471.1,
    y1: 152.8,
    x2: 476.4,
    y2: 131
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2369 -0.9715 0.9715 0.2369 211.0204 574.2392)",
    fill: "#808989",
    cx: 471.1,
    cy: 152.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2369 -0.9715 0.9715 0.2369 236.2103 562.7898)",
    fill: "#808989",
    cx: 476.4,
    cy: 131,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 471.1,
    y1: 152.8,
    x2: 462.2,
    y2: 143.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7168 -0.6973 0.6973 0.7168 26.8854 371.7599)",
    fill: "#808989",
    cx: 471.1,
    cy: 152.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7168 -0.6973 0.6973 0.7168 30.7477 362.9476)",
    fill: "#808989",
    cx: 462.2,
    cy: 143.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 411.6,
    y1: 166.6,
    x2: 374.8,
    y2: 131.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6903 -0.7235 0.7235 0.6903 6.9231 349.41)",
    fill: "#808989",
    cx: 411.6,
    cy: 166.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6903 -0.7235 0.7235 0.6903 20.964 311.8336)",
    fill: "#808989",
    cx: 374.8,
    cy: 131.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 359.1,
    y1: 167.3,
    x2: 402.3,
    y2: 148.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9205 -0.3907 0.3907 0.9205 -36.8156 153.5891)",
    fill: "#808989",
    cx: 359.1,
    cy: 167.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9205 -0.3907 0.3907 0.9205 -26.1972 169.0362)",
    fill: "#808989",
    cx: 402.3,
    cy: 148.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 414.5,
    y1: 157.3,
    x2: 439.9,
    y2: 168.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4091 -0.9125 0.9125 0.4091 101.3886 471.1917)",
    fill: "#808989",
    cx: 414.5,
    cy: 157.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4091 -0.9125 0.9125 0.4091 106.007 501.0859)",
    fill: "#808989",
    cx: 439.9,
    cy: 168.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 392.7,
    y1: 166,
    x2: 414.5,
    y2: 157.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9294 -0.369 0.369 0.9294 -33.5258 156.6176)",
    fill: "#808989",
    cx: 392.7,
    cy: 166,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9294 -0.369 0.369 0.9294 -28.7991 164.039)",
    fill: "#808989",
    cx: 414.5,
    cy: 157.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 370,
    y1: 156.7,
    x2: 392.7,
    y2: 166
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3769 -0.9263 0.9263 0.3769 85.3956 440.3833)",
    fill: "#808989",
    cx: 370,
    cy: 156.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3769 -0.9263 0.9263 0.3769 90.9906 467.1763)",
    fill: "#808989",
    cx: 392.7,
    cy: 166,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 373.6,
    y1: 147.2,
    x2: 392.7,
    y2: 166
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7006 -0.7136 0.7136 0.7006 6.8462 310.635)",
    fill: "#808989",
    cx: 373.6,
    cy: 147.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7006 -0.7136 0.7136 0.7006 -0.8359 329.9315)",
    fill: "#808989",
    cx: 392.7,
    cy: 166,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 399.9,
    y1: 126.7,
    x2: 373.6,
    y2: 147.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7905 -0.6125 0.6125 0.7905 6.1744 271.5004)",
    fill: "#808989",
    cx: 399.9,
    cy: 126.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7905 -0.6125 0.6125 0.7905 -11.8668 259.6289)",
    fill: "#808989",
    cx: 373.6,
    cy: 147.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 374.8,
    y1: 131.4,
    x2: 403.2,
    y2: 93.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5967 -0.8024 0.8024 0.5967 45.6637 353.7194)",
    fill: "#808989",
    cx: 374.8,
    cy: 131.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5967 -0.8024 0.8024 0.5967 87.758 361.1085)",
    fill: "#808989",
    cx: 403.2,
    cy: 93.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 401.4,
    y1: 78.7,
    x2: 374.8,
    y2: 131.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4513 -0.8924 0.8924 0.4513 149.9748 401.4024)",
    fill: "#808989",
    cx: 401.4,
    cy: 78.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4513 -0.8924 0.8924 0.4513 88.3389 406.5299)",
    fill: "#808989",
    cx: 374.8,
    cy: 131.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M374.8,131.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 388.3,
    y1: 17.2,
    x2: 374.8,
    y2: 131.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1177 -0.993 0.993 0.1177 325.463 400.8121)",
    fill: "#808989",
    cx: 388.3,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1177 -0.993 0.993 0.1177 200.1255 488.1094)",
    fill: "#808989",
    cx: 374.8,
    cy: 131.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 399.9,
    y1: 126.7,
    x2: 374.8,
    y2: 96.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7646 -0.6446 0.6446 0.7646 12.4812 287.619)",
    fill: "#808989",
    cx: 399.9,
    cy: 126.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7646 -0.6446 0.6446 0.7646 25.7987 264.3651)",
    fill: "#808989",
    cx: 374.8,
    cy: 96.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 399.9,
    y1: 65.8,
    x2: 374.8,
    y2: 96.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6298 -0.7767 0.7767 0.6298 96.9213 335.0171)",
    fill: "#808989",
    cx: 399.9,
    cy: 65.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6298 -0.7767 0.7767 0.6298 63.4911 326.9579)",
    fill: "#808989",
    cx: 374.8,
    cy: 96.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 374.8,
    y1: 44.8,
    x2: 399.9,
    y2: 65.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6415 -0.7671 0.7671 0.6415 100.0079 303.55)",
    fill: "#808989",
    cx: 374.8,
    cy: 44.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6415 -0.7671 0.7671 0.6415 92.8858 330.4048)",
    fill: "#808989",
    cx: 399.9,
    cy: 65.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 374.8,
    y1: 44.8,
    x2: 399.9,
    y2: 50.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2319 -0.9727 0.9727 0.2319 244.2939 398.9413)",
    fill: "#808989",
    cx: 374.8,
    cy: 44.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2319 -0.9727 0.9727 0.2319 257.7896 428.0345)",
    fill: "#808989",
    cx: 399.9,
    cy: 50.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 370.8,
    y1: 28.2,
    x2: 399.9,
    y2: 50.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6127 -0.7903 0.7903 0.6127 121.3387 303.9392)",
    fill: "#808989",
    cx: 370.8,
    cy: 28.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6127 -0.7903 0.7903 0.6127 114.7654 335.7445)",
    fill: "#808989",
    cx: 399.9,
    cy: 50.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 374.5,
    y1: 17,
    x2: 399.9,
    y2: 50.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7992 -0.601 0.601 0.7992 64.9657 228.5233)",
    fill: "#808989",
    cx: 374.5,
    cy: 17,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7992 -0.601 0.601 0.7992 49.7715 250.56)",
    fill: "#808989",
    cx: 399.9,
    cy: 50.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 370.8,
    y1: 28.2,
    x2: 374.5,
    y2: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3206 -0.9472 0.9472 0.3206 225.2018 370.3319)",
    fill: "#808989",
    cx: 370.8,
    cy: 28.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3206 -0.9472 0.9472 0.3206 238.3304 366.3313)",
    fill: "#808989",
    cx: 374.5,
    cy: 17,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 354.2,
    y1: 22.1,
    x2: 374.5,
    y2: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9708 -0.2401 0.2401 0.9708 5.065 85.6811)",
    fill: "#808989",
    cx: 354.2,
    cy: 22.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9708 -0.2401 0.2401 0.9708 6.869 90.4209)",
    fill: "#808989",
    cx: 374.5,
    cy: 17,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 351.9,
    y1: 16.3,
    x2: 370.8,
    y2: 28.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.535 -0.8449 0.8449 0.535 149.9415 304.9131)",
    fill: "#808989",
    cx: 351.9,
    cy: 16.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5349 -0.8449 0.8449 0.5349 148.6258 326.359)",
    fill: "#808989",
    cx: 370.8,
    cy: 28.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 388.3,
    y1: 17.2,
    x2: 400,
    y2: 37.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8662 -0.4997 0.4997 0.8662 43.3468 196.3537)",
    fill: "#808989",
    cx: 388.3,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8662 -0.4997 0.4997 0.8662 34.7484 204.9469)",
    fill: "#808989",
    cx: 400,
    cy: 37.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 405.6,
    y1: 26.5,
    x2: 388.3,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.473 -0.8811 0.8811 0.473 190.3891 371.3724)",
    fill: "#808989",
    cx: 405.6,
    cy: 26.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.473 -0.8811 0.8811 0.473 189.4529 351.2088)",
    fill: "#808989",
    cx: 388.3,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 416,
    y1: 17.5,
    x2: 405.6,
    y2: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7531 -0.658 0.658 0.7531 91.2495 278.0361)",
    fill: "#808989",
    cx: 416,
    cy: 17.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7531 -0.658 0.658 0.7531 82.706 273.4391)",
    fill: "#808989",
    cx: 405.6,
    cy: 26.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 388.3,
    y1: 17.2,
    x2: 426.4,
    y2: 25.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2158 -0.9764 0.9764 0.2158 287.6758 392.6739)",
    fill: "#808989",
    cx: 388.3,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2158 -0.9764 0.9764 0.2158 309.3454 436.4985)",
    fill: "#808989",
    cx: 426.4,
    cy: 25.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 461.7,
    y1: 16.4,
    x2: 426.4,
    y2: 25.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9669 -0.2552 0.2552 0.9669 11.1136 118.3693)",
    fill: "#808989",
    cx: 461.7,
    cy: 16.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9669 -0.2552 0.2552 0.9669 7.5724 109.6835)",
    fill: "#808989",
    cx: 426.4,
    cy: 25.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 464.8,
    y1: 20,
    x2: 426.4,
    y2: 25.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9892 -0.1465 0.1465 0.9892 2.0909 68.3312)",
    fill: "#808989",
    cx: 464.8,
    cy: 20,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9892 -0.1465 0.1465 0.9892 0.8421 62.7597)",
    fill: "#808989",
    cx: 426.4,
    cy: 25.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 452.1,
    y1: 30.6,
    x2: 416,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3414 -0.9399 0.9399 0.3414 269.0025 445.0361)",
    fill: "#808989",
    cx: 452.1,
    cy: 30.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3414 -0.9399 0.9399 0.3414 257.5638 402.5146)",
    fill: "#808989",
    cx: 416,
    cy: 17.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 464.8,
    y1: 20,
    x2: 452.1,
    y2: 30.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7695 -0.6387 0.6387 0.7695 94.4044 301.489)",
    fill: "#808989",
    cx: 464.8,
    cy: 20,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7695 -0.6387 0.6387 0.7695 84.7061 295.7858)",
    fill: "#808989",
    cx: 452.1,
    cy: 30.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 466.4,
    y1: 42.6,
    x2: 452.1,
    y2: 30.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6455 -0.7638 0.7638 0.6455 132.7678 371.2994)",
    fill: "#808989",
    cx: 466.4,
    cy: 42.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6455 -0.7638 0.7638 0.6455 136.9238 356.1128)",
    fill: "#808989",
    cx: 452.1,
    cy: 30.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 401.4,
    y1: 78.7,
    x2: 410.3,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8228 -0.5683 0.5683 0.8228 26.3713 242.0681)",
    fill: "#808989",
    cx: 401.4,
    cy: 78.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8228 -0.5683 0.5683 0.8228 20.6126 249.424)",
    fill: "#808989",
    cx: 410.3,
    cy: 91.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 426,
    y1: 81.3,
    x2: 410.3,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.833 -0.5533 0.5533 0.833 26.1922 249.2803)",
    fill: "#808989",
    cx: 426,
    cy: 81.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.833 -0.5533 0.5533 0.833 17.8259 242.3574)",
    fill: "#808989",
    cx: 410.3,
    cy: 91.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 433.1,
    y1: 92.4,
    x2: 426,
    y2: 81.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8414 -0.5404 0.5404 0.8414 18.7465 248.7207)",
    fill: "#808989",
    cx: 433.1,
    cy: 92.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8414 -0.5404 0.5404 0.8414 23.6417 243.0779)",
    fill: "#808989",
    cx: 426,
    cy: 81.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 452.4,
    y1: 65.3,
    x2: 433.1,
    y2: 92.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5778 -0.8162 0.8162 0.5778 137.7325 396.7754)",
    fill: "#808989",
    cx: 452.4,
    cy: 65.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5778 -0.8162 0.8162 0.5778 107.4496 392.5521)",
    fill: "#808989",
    cx: 433.1,
    cy: 92.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 411.9,
    y1: 81.4,
    x2: 410.3,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1473 -0.9891 0.9891 0.1473 270.7056 476.7485)",
    fill: "#808989",
    cx: 411.9,
    cy: 81.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1473 -0.9891 0.9891 0.1473 259.2246 484.0042)",
    fill: "#808989",
    cx: 410.3,
    cy: 91.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 403.2,
    y1: 93.2,
    x2: 374.8,
    y2: 44.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8628 -0.5056 0.5056 0.8628 8.1852 216.6357)",
    fill: "#808989",
    cx: 403.2,
    cy: 93.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8628 -0.5056 0.5056 0.8628 28.7896 195.6267)",
    fill: "#808989",
    cx: 374.8,
    cy: 44.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 452.4,
    y1: 65.3,
    x2: 442.7,
    y2: 69.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9214 -0.3885 0.3885 0.9214 10.1833 180.8825)",
    fill: "#808989",
    cx: 452.4,
    cy: 65.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9214 -0.3885 0.3885 0.9214 7.8439 177.4522)",
    fill: "#808989",
    cx: 442.7,
    cy: 69.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 440.1,
    y1: 95.8,
    x2: 442.7,
    y2: 69.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.865650e-02 -0.9951 0.9951 9.865650e-02 301.3345 524.3115)",
    fill: "#808989",
    cx: 440.1,
    cy: 95.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.865531e-02 -0.9951 0.9951 9.865531e-02 330.0552 503.0541)",
    fill: "#808989",
    cx: 442.7,
    cy: 69.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 446.7,
    y1: 109.9,
    x2: 447.5,
    y2: 60.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.649948e-02 -0.9999 0.9999 1.649948e-02 329.3787 554.7189)",
    fill: "#808989",
    cx: 446.7,
    cy: 109.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.649932e-02 -0.9999 0.9999 1.649932e-02 379.757 506.7747)",
    fill: "#808989",
    cx: 447.5,
    cy: 60.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 442.7,
    y1: 69.3,
    x2: 451.8,
    y2: 113.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9793 -0.2022 0.2022 0.9793 -4.8727 90.9705)",
    fill: "#808989",
    cx: 442.7,
    cy: 69.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9793 -0.2022 0.2022 0.9793 -13.5817 93.7153)",
    fill: "#808989",
    cx: 451.8,
    cy: 113.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 450.7,
    y1: 76.8,
    x2: 433.1,
    y2: 92.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7464 -0.6655 0.6655 0.7464 63.1636 319.3738)",
    fill: "#808989",
    cx: 450.7,
    cy: 76.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7464 -0.6655 0.6655 0.7464 48.3299 311.6769)",
    fill: "#808989",
    cx: 433.1,
    cy: 92.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 402.3,
    y1: 148.9,
    x2: 392.7,
    y2: 166
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4916 -0.8708 0.8708 0.4916 74.8699 426.0554)",
    fill: "#808989",
    cx: 402.3,
    cy: 148.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4916 -0.8708 0.8708 0.4916 55.1205 426.3422)",
    fill: "#808989",
    cx: 392.7,
    cy: 166,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 502,
    y1: 152.4,
    x2: 540.1,
    y2: 167.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3666 -0.9304 0.9304 0.3666 176.2048 563.5392)",
    fill: "#808989",
    cx: 502,
    cy: 152.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3666 -0.9304 0.9304 0.3666 186.3744 608.5292)",
    fill: "#808989",
    cx: 540.1,
    cy: 167.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 543.5,
    y1: 164,
    x2: 490.3,
    y2: 161.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.211124e-02 -0.9991 0.9991 4.211124e-02 356.7294 700.1704)",
    fill: "#808989",
    cx: 543.5,
    cy: 164,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.211104e-02 -0.9991 0.9991 4.211104e-02 308.0222 644.8835)",
    fill: "#808989",
    cx: 490.3,
    cy: 161.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 487.2,
    y1: 167.6,
    x2: 490.3,
    y2: 161.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4728 -0.8811 0.8811 0.4728 109.1555 517.6612)",
    fill: "#808989",
    cx: 487.2,
    cy: 167.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4728 -0.8811 0.8811 0.4728 115.9089 517.3477)",
    fill: "#808989",
    cx: 490.3,
    cy: 161.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 518.9,
    y1: 147.4,
    x2: 487.2,
    y2: 167.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8428 -0.5383 0.5383 0.8428 2.2632 302.4893)",
    fill: "#808989",
    cx: 518.9,
    cy: 147.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8428 -0.5383 0.5383 0.8428 -13.6088 288.6185)",
    fill: "#808989",
    cx: 487.2,
    cy: 167.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 502,
    y1: 152.4,
    x2: 515.4,
    y2: 165.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6962 -0.7178 0.7178 0.6962 43.1247 406.6208)",
    fill: "#808989",
    cx: 502,
    cy: 152.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6962 -0.7178 0.7178 0.6962 37.8422 420.2488)",
    fill: "#808989",
    cx: 515.4,
    cy: 165.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 516.1,
    y1: 125.8,
    x2: 502,
    y2: 152.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4688 -0.8833 0.8833 0.4688 162.9694 522.6749)",
    fill: "#808989",
    cx: 516.1,
    cy: 125.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4688 -0.8833 0.8833 0.4688 132.0661 524.3293)",
    fill: "#808989",
    cx: 502,
    cy: 152.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 506.4,
    y1: 105.8,
    x2: 516.1,
    y2: 125.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9011 -0.4337 0.4337 0.9011 4.2185 230.0801)",
    fill: "#808989",
    cx: 506.4,
    cy: 105.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9011 -0.4337 0.4337 0.9011 -3.5191 236.246)",
    fill: "#808989",
    cx: 516.1,
    cy: 125.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 506.4,
    y1: 58.4,
    x2: 516.1,
    y2: 125.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9899 -0.1416 0.1416 0.9899 -3.1681 72.3082)",
    fill: "#808989",
    cx: 506.4,
    cy: 58.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9899 -0.1416 0.1416 0.9899 -12.6197 74.3545)",
    fill: "#808989",
    cx: 516.1,
    cy: 125.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 518.5,
    y1: 16,
    x2: 506.4,
    y2: 58.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2733 -0.9619 0.9619 0.2733 361.3597 510.3752)",
    fill: "#808989",
    cx: 518.5,
    cy: 16,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2733 -0.9619 0.9619 0.2733 311.8453 529.5928)",
    fill: "#808989",
    cx: 506.4,
    cy: 58.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 517.3,
    y1: 47.9,
    x2: 506.4,
    y2: 58.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7173 -0.6968 0.6968 0.7173 112.8694 373.9449)",
    fill: "#808989",
    cx: 517.3,
    cy: 47.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7173 -0.6968 0.6968 0.7173 102.4686 369.3708)",
    fill: "#808989",
    cx: 506.4,
    cy: 58.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 515.6,
    y1: 56.3,
    x2: 506.4,
    y2: 58.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9747 -0.2237 0.2237 0.9747 0.4718 116.7673)",
    fill: "#808989",
    cx: 515.6,
    cy: 56.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9747 -0.2237 0.2237 0.9747 -0.2332 114.7642)",
    fill: "#808989",
    cx: 506.4,
    cy: 58.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 515.5,
    y1: 101.9,
    x2: 506.4,
    y2: 105.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9189 -0.3946 0.3946 0.9189 1.6255 211.6884)",
    fill: "#808989",
    cx: 515.5,
    cy: 101.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9188 -0.3946 0.3946 0.9188 -0.6502 208.4252)",
    fill: "#808989",
    cx: 506.4,
    cy: 105.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 505.8,
    y1: 37.7,
    x2: 515.5,
    y2: 101.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9888 -0.149 0.149 0.9888 3.346317e-02 75.7962)",
    fill: "#808989",
    cx: 505.8,
    cy: 37.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9888 -0.149 0.149 0.9888 -9.4278 77.9546)",
    fill: "#808989",
    cx: 515.5,
    cy: 101.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 532.1,
    y1: 26.5,
    x2: 505.8,
    y2: 37.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9208 -0.3901 0.3901 0.9208 31.807 209.6843)",
    fill: "#808989",
    cx: 532.1,
    cy: 26.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9208 -0.3901 0.3901 0.9208 25.3821 200.3181)",
    fill: "#808989",
    cx: 505.8,
    cy: 37.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 512.4,
    y1: 16.4,
    x2: 505.8,
    y2: 37.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2956 -0.9553 0.9553 0.2956 345.2943 501.0378)",
    fill: "#808989",
    cx: 512.4,
    cy: 16.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2956 -0.9553 0.9553 0.2956 320.2883 509.7486)",
    fill: "#808989",
    cx: 505.8,
    cy: 37.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 494.1,
    y1: 17.3,
    x2: 505.8,
    y2: 37.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8661 -0.4998 0.4998 0.8661 57.4691 249.2702)",
    fill: "#808989",
    cx: 494.1,
    cy: 17.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8661 -0.4998 0.4998 0.8661 48.8794 257.854)",
    fill: "#808989",
    cx: 505.8,
    cy: 37.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 512.4,
    y1: 16.4,
    x2: 495,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8433 -0.5375 0.5375 0.8433 71.521 277.9913)",
    fill: "#808989",
    cx: 512.4,
    cy: 16.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8433 -0.5375 0.5375 0.8433 62.8206 270.3669)",
    fill: "#808989",
    cx: 495,
    cy: 27.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 481.9,
    y1: 17.1,
    x2: 495,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6201 -0.7846 0.7846 0.6201 169.6628 384.597)",
    fill: "#808989",
    cx: 481.9,
    cy: 17.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6201 -0.7846 0.7846 0.6201 166.5186 398.7873)",
    fill: "#808989",
    cx: 495,
    cy: 27.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 494.1,
    y1: 17.3,
    x2: 481.6,
    y2: 23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 37.1157 206.0279)",
    fill: "#808989",
    cx: 494.1,
    cy: 17.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9104 -0.4138 0.4138 0.9104 33.6384 201.3574)",
    fill: "#808989",
    cx: 481.6,
    cy: 23,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 512.4,
    y1: 16.4,
    x2: 478.2,
    y2: 20.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9936 -0.1129 0.1129 0.9936 1.427 57.9329)",
    fill: "#808989",
    cx: 512.4,
    cy: 16.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9936 -0.1129 0.1129 0.9936 0.7698 54.0987)",
    fill: "#808989",
    cx: 478.2,
    cy: 20.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 523.8,
    y1: 17.5,
    x2: 505.8,
    y2: 37.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6656 -0.7463 0.7463 0.6656 162.1083 396.7918)",
    fill: "#808989",
    cx: 523.8,
    cy: 17.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6656 -0.7463 0.7463 0.6656 141.0456 390.1148)",
    fill: "#808989",
    cx: 505.8,
    cy: 37.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 532.1,
    y1: 26.5,
    x2: 551.4,
    y2: 87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9529 -0.3034 0.3034 0.9529 17.0321 162.7013)",
    fill: "#808989",
    cx: 532.1,
    cy: 26.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9529 -0.3034 0.3034 0.9529 -0.419 171.3997)",
    fill: "#808989",
    cx: 551.4,
    cy: 87,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 573.8,
    y1: 74.1,
    x2: 551.4,
    y2: 87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8668 -0.4986 0.4986 0.8668 39.4638 296.009)",
    fill: "#808989",
    cx: 573.8,
    cy: 74.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8668 -0.4986 0.4986 0.8668 30.0334 286.5342)",
    fill: "#808989",
    cx: 551.4,
    cy: 87,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 573.8,
    y1: 74.1,
    x2: 599.5,
    y2: 140.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9328 -0.3604 0.3604 0.9328 11.8447 211.7888)",
    fill: "#808989",
    cx: 573.8,
    cy: 74.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9328 -0.3604 0.3604 0.9328 -10.3476 225.4883)",
    fill: "#808989",
    cx: 599.5,
    cy: 140.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 627.7,
    y1: 120.8,
    x2: 599.5,
    y2: 140.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8198 -0.5726 0.5726 0.8198 43.9251 381.1879)",
    fill: "#808989",
    cx: 627.7,
    cy: 120.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8198 -0.5726 0.5726 0.8198 27.565 368.5833)",
    fill: "#808989",
    cx: 599.5,
    cy: 140.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 620,
    y1: 66.5,
    x2: 627.7,
    y2: 120.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9902 -0.1395 0.1395 0.9902 -3.221 87.1197)",
    fill: "#808989",
    cx: 620,
    cy: 66.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9902 -0.1395 0.1395 0.9902 -10.713 88.7139)",
    fill: "#808989",
    cx: 627.7,
    cy: 120.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 629.2,
    y1: 52.5,
    x2: 620,
    y2: 66.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5464 -0.8375 0.8375 0.5464 241.4693 550.7621)",
    fill: "#808989",
    cx: 629.2,
    cy: 52.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5464 -0.8375 0.8375 0.5464 225.495 549.4501)",
    fill: "#808989",
    cx: 620,
    cy: 66.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 616.1,
    y1: 17.9,
    x2: 629.2,
    y2: 52.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9352 -0.354 0.354 0.9352 33.5669 219.2794)",
    fill: "#808989",
    cx: 616.1,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9352 -0.354 0.354 0.9352 22.1791 226.1488)",
    fill: "#808989",
    cx: 629.2,
    cy: 52.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 545,
    y1: 41.8,
    x2: 517.3,
    y2: 47.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9764 -0.2158 0.2158 0.9764 3.831 118.5891)",
    fill: "#808989",
    cx: 545,
    cy: 41.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9764 -0.2158 0.2158 0.9764 1.8549 112.7489)",
    fill: "#808989",
    cx: 517.3,
    cy: 47.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 545,
    y1: 41.8,
    x2: 538.4,
    y2: 71.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.214 -0.9768 0.9768 0.214 387.5872 565.1848)",
    fill: "#808989",
    cx: 545,
    cy: 41.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.214 -0.9768 0.9768 0.214 352.9186 582.4459)",
    fill: "#808989",
    cx: 538.4,
    cy: 71.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 545,
    y1: 41.8,
    x2: 599.5,
    y2: 140.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8756 -0.483 0.483 0.8756 47.6281 268.4412)",
    fill: "#808989",
    cx: 545,
    cy: 41.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8756 -0.483 0.483 0.8756 6.7094 307.0343)",
    fill: "#808989",
    cx: 599.5,
    cy: 140.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 627.2,
    y1: 130.2,
    x2: 599.5,
    y2: 140.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9376 -0.3476 0.3476 0.9376 -6.1461 226.1477)",
    fill: "#808989",
    cx: 627.2,
    cy: 130.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9376 -0.3476 0.3476 0.9376 -11.4527 217.1433)",
    fill: "#808989",
    cx: 599.5,
    cy: 140.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 573.8,
    y1: 74.1,
    x2: 628.3,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8632 -0.5049 0.5049 0.8632 41.0882 299.8816)",
    fill: "#808989",
    cx: 573.8,
    cy: 74.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8632 -0.5049 0.5049 0.8632 1.5127 340.1308)",
    fill: "#808989",
    cx: 628.3,
    cy: 167.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 616.5,
    y1: 119.2,
    x2: 628.3,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9712 -0.2383 0.2383 0.9712 -10.6511 150.3729)",
    fill: "#808989",
    cx: 616.5,
    cy: 119.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9712 -0.2383 0.2383 0.9712 -21.7614 154.5657)",
    fill: "#808989",
    cx: 628.3,
    cy: 167.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 616.5,
    y1: 119.2,
    x2: 627.2,
    y2: 130.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7161 -0.698 0.698 0.7161 91.8032 464.1747)",
    fill: "#808989",
    cx: 616.5,
    cy: 119.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7161 -0.698 0.698 0.7161 87.1814 474.753)",
    fill: "#808989",
    cx: 627.2,
    cy: 130.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 619,
    y1: 112.6,
    x2: 627.2,
    y2: 130.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9072 -0.4208 0.4208 0.9072 10.1032 270.9186)",
    fill: "#808989",
    cx: 619,
    cy: 112.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9072 -0.4208 0.4208 0.9072 3.4401 275.9991)",
    fill: "#808989",
    cx: 627.2,
    cy: 130.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 616.5,
    y1: 119.2,
    x2: 627.7,
    y2: 120.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1393 -0.9903 0.9903 0.1393 412.5891 713.1378)",
    fill: "#808989",
    cx: 616.5,
    cy: 119.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1393 -0.9903 0.9903 0.1393 420.6119 725.5098)",
    fill: "#808989",
    cx: 627.7,
    cy: 120.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 616.1,
    y1: 17.9,
    x2: 607.1,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7978 -0.6029 0.6029 0.7978 113.7683 375.0598)",
    fill: "#808989",
    cx: 616.1,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7978 -0.6029 0.6029 0.7978 107.8365 370.9962)",
    fill: "#808989",
    cx: 607.1,
    cy: 24.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 631.1,
    y1: 33.4,
    x2: 616.1,
    y2: 17.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7205 -0.6934 0.6934 0.7205 153.1793 446.9271)",
    fill: "#808989",
    cx: 631.1,
    cy: 33.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7205 -0.6934 0.6934 0.7205 159.7764 432.2313)",
    fill: "#808989",
    cx: 616.1,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 614.8,
    y1: 31.8,
    x2: 616.1,
    y2: 17.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.381245e-02 -0.9956 0.9956 9.381245e-02 525.4962 640.9016)",
    fill: "#808989",
    cx: 614.8,
    cy: 31.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.381223e-02 -0.9956 0.9956 9.381223e-02 540.5074 629.6206)",
    fill: "#808989",
    cx: 616.1,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 614.8,
    y1: 31.8,
    x2: 629.1,
    y2: 17.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6963 -0.7177 0.7177 0.6963 163.8829 450.9075)",
    fill: "#808989",
    cx: 614.8,
    cy: 31.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6963 -0.7177 0.7177 0.6963 178.7654 456.6804)",
    fill: "#808989",
    cx: 629.1,
    cy: 17.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 614.8,
    y1: 31.8,
    x2: 643.3,
    y2: 15.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8696 -0.4938 0.4938 0.8696 64.4976 307.7482)",
    fill: "#808989",
    cx: 614.8,
    cy: 31.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8696 -0.4938 0.4938 0.8696 76.2022 319.7018)",
    fill: "#808989",
    cx: 643.3,
    cy: 15.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 636.2,
    y1: 25.4,
    x2: 614.8,
    y2: 31.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9577 -0.2877 0.2877 0.9577 19.6005 184.1021)",
    fill: "#808989",
    cx: 636.2,
    cy: 25.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9577 -0.2877 0.2877 0.9577 16.8486 178.2168)",
    fill: "#808989",
    cx: 614.8,
    cy: 31.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 646.8,
    y1: 18.7,
    x2: 614.8,
    y2: 31.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9258 -0.378 0.378 0.9258 40.906 245.8583)",
    fill: "#808989",
    cx: 646.8,
    cy: 18.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9258 -0.3779 0.3779 0.9258 33.5892 234.7188)",
    fill: "#808989",
    cx: 614.8,
    cy: 31.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 594,
    y1: 16.1,
    x2: 607.1,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5459 -0.8379 0.8379 0.5459 256.2117 505.0006)",
    fill: "#808989",
    cx: 594,
    cy: 16.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5459 -0.8379 0.8379 0.5459 255.0064 519.8964)",
    fill: "#808989",
    cx: 607.1,
    cy: 24.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 616.1,
    y1: 17.9,
    x2: 590.8,
    y2: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999 -4.547379e-02 4.547379e-02 0.999 -0.1764 28.0359)",
    fill: "#808989",
    cx: 616.1,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999 -4.545451e-02 4.545451e-02 0.999 -0.2551 26.8739)",
    fill: "#808989",
    cx: 590.8,
    cy: 19,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 646.8,
    y1: 18.7,
    x2: 629.1,
    y2: 17.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.170128e-02 -0.9958 0.9958 9.170128e-02 568.8749 661.0958)",
    fill: "#808989",
    cx: 646.8,
    cy: 18.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.168212e-02 -0.9958 0.9958 9.168212e-02 554.3951 641.9414)",
    fill: "#808989",
    cx: 629.1,
    cy: 17.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 629.2,
    y1: 52.5,
    x2: 618.2,
    y2: 42.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.686 -0.7276 0.7276 0.686 159.424 474.3022)",
    fill: "#808989",
    cx: 629.2,
    cy: 52.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.686 -0.7276 0.7276 0.686 163.5162 463.062)",
    fill: "#808989",
    cx: 618.2,
    cy: 42.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 629.2,
    y1: 47.1,
    x2: 618.2,
    y2: 42.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.414 -0.9103 0.9103 0.414 325.8328 600.3404)",
    fill: "#808989",
    cx: 629.2,
    cy: 47.1,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.414 -0.9103 0.9103 0.414 323.9341 587.4062)",
    fill: "#808989",
    cx: 618.2,
    cy: 42.1,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 505.8,
    y1: 37.7,
    x2: 517.3,
    y2: 47.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6659 -0.7461 0.7461 0.6659 140.91 389.9744)",
    fill: "#808989",
    cx: 505.8,
    cy: 37.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6659 -0.7461 0.7461 0.6659 137.1168 401.9155)",
    fill: "#808989",
    cx: 517.3,
    cy: 47.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 462.1,
    y1: 51.2,
    x2: 452.1,
    y2: 30.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8994 -0.4371 0.4371 0.8994 24.1128 207.1142)",
    fill: "#808989",
    cx: 462.1,
    cy: 51.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8994 -0.4371 0.4371 0.8994 32.1121 200.6655)",
    fill: "#808989",
    cx: 452.1,
    cy: 30.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 361.5,
    y1: 161.8,
    x2: 368.4,
    y2: 166.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.598 -0.8015 0.8015 0.598 15.6498 354.8069)",
    fill: "#808989",
    cx: 361.5,
    cy: 161.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.598 -0.8015 0.8015 0.598 14.2987 362.3999)",
    fill: "#808989",
    cx: 368.4,
    cy: 166.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 402.3,
    y1: 148.9,
    x2: 368.4,
    y2: 166.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8829 -0.4696 0.4696 0.8829 -22.8053 206.3569)",
    fill: "#808989",
    cx: 402.3,
    cy: 148.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8829 -0.4696 0.4696 0.8829 -35.25 192.5387)",
    fill: "#808989",
    cx: 368.4,
    cy: 166.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 710.4,
    y1: 134,
    x2: 735.6,
    y2: 43.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2673 -0.9636 0.9636 0.2673 391.3531 782.7271)",
    fill: "#808989",
    cx: 710.4,
    cy: 134,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2673 -0.9636 0.9636 0.2673 497.2155 740.5135)",
    fill: "#808989",
    cx: 735.6,
    cy: 43.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 735.6,
    y1: 94.5,
    x2: 710.4,
    y2: 134
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5369 -0.8437 0.8437 0.5369 260.9775 664.3202)",
    fill: "#808989",
    cx: 735.6,
    cy: 94.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5369 -0.8437 0.8437 0.5369 215.9497 661.4023)",
    fill: "#808989",
    cx: 710.4,
    cy: 134,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 740.9,
    y1: 151.9,
    x2: 710.4,
    y2: 134
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5056 -0.8628 0.8628 0.5056 235.2629 714.3525)",
    fill: "#808989",
    cx: 740.9,
    cy: 151.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5056 -0.8628 0.8628 0.5056 235.6054 679.1649)",
    fill: "#808989",
    cx: 710.4,
    cy: 134,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 735.6,
    y1: 125.7,
    x2: 710.4,
    y2: 110.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5069 -0.862 0.862 0.5069 254.3439 696.0268)",
    fill: "#808989",
    cx: 735.6,
    cy: 125.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5069 -0.862 0.862 0.5069 254.6925 667.0313)",
    fill: "#808989",
    cx: 710.4,
    cy: 110.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 735.6,
    y1: 125.7,
    x2: 710.4,
    y2: 134
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9495 -0.3137 0.3137 0.9495 -2.2939 237.1232)",
    fill: "#808989",
    cx: 735.6,
    cy: 125.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9495 -0.3137 0.3137 0.9495 -6.1741 229.6464)",
    fill: "#808989",
    cx: 710.4,
    cy: 134,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 735.6,
    y1: 94.5,
    x2: 710.4,
    y2: 83.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3892 -0.9212 0.9212 0.3892 362.3096 735.2842)",
    fill: "#808989",
    cx: 735.6,
    cy: 94.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3892 -0.9212 0.9212 0.3892 356.7296 705.6024)",
    fill: "#808989",
    cx: 710.4,
    cy: 83.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 735.6,
    y1: 43.3,
    x2: 710.4,
    y2: 60.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8236 -0.5672 0.5672 0.8236 105.2084 424.8355)",
    fill: "#808989",
    cx: 735.6,
    cy: 43.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8236 -0.5672 0.5672 0.8236 90.9374 413.6176)",
    fill: "#808989",
    cx: 710.4,
    cy: 60.6,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 735.6,
    y1: 43.3,
    x2: 697.4,
    y2: 18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5519 -0.8339 0.8339 0.5519 293.4875 632.7774)",
    fill: "#808989",
    cx: 735.6,
    cy: 43.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5519 -0.8339 0.8339 0.5519 297.4639 589.6074)",
    fill: "#808989",
    cx: 697.4,
    cy: 18,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 735.6,
    y1: 43.3,
    x2: 724,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9068 -0.4216 0.4216 0.9068 50.322 314.1565)",
    fill: "#808989",
    cx: 735.6,
    cy: 43.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9068 -0.4216 0.4216 0.9068 59.7577 306.9341)",
    fill: "#808989",
    cx: 724,
    cy: 18.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 710.4,
    y1: 36.8,
    x2: 735.6,
    y2: 43.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2485 -0.9686 0.9686 0.2485 498.2052 715.799)",
    fill: "#808989",
    cx: 710.4,
    cy: 36.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2485 -0.9686 0.9686 0.2485 510.8665 745.032)",
    fill: "#808989",
    cx: 735.6,
    cy: 43.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 720,
    y1: 165.9,
    x2: 710.4,
    y2: 134
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9572 -0.2894 0.2894 0.9572 -17.184 215.5024)",
    fill: "#808989",
    cx: 720,
    cy: 165.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9572 -0.2894 0.2894 0.9572 -8.3784 211.3562)",
    fill: "#808989",
    cx: 710.4,
    cy: 134,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 705.9,
    y1: 154.5,
    x2: 720,
    y2: 165.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6243 -0.7812 0.7812 0.6243 144.458 609.4378)",
    fill: "#808989",
    cx: 705.9,
    cy: 154.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6243 -0.7812 0.7812 0.6243 140.9341 624.7625)",
    fill: "#808989",
    cx: 720,
    cy: 165.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 710.4,
    y1: 134,
    x2: 749.5,
    y2: 166.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6396 -0.7687 0.7687 0.6396 153.0392 594.4146)",
    fill: "#808989",
    cx: 710.4,
    cy: 134,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6396 -0.7687 0.7687 0.6396 142.1359 636.1646)",
    fill: "#808989",
    cx: 749.5,
    cy: 166.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 759.9,
    y1: 160.5,
    x2: 749.5,
    y2: 166.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8655 -0.501 0.501 0.8655 21.8331 402.2769)",
    fill: "#808989",
    cx: 759.9,
    cy: 160.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8655 -0.501 0.501 0.8655 17.4185 397.8761)",
    fill: "#808989",
    cx: 749.5,
    cy: 166.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 763.8,
    y1: 164.4,
    x2: 705.9,
    y2: 154.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1678 -0.9858 0.9858 0.1678 473.6106 889.7933)",
    fill: "#808989",
    cx: 763.8,
    cy: 164.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1678 -0.9858 0.9858 0.1678 435.0952 824.4557)",
    fill: "#808989",
    cx: 705.9,
    cy: 154.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 759.9,
    y1: 160.5,
    x2: 760.4,
    y2: 166.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9964 -8.436331e-02 8.436331e-02 0.9964 -10.8306 64.6774)",
    fill: "#808989",
    cx: 759.9,
    cy: 160.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9964 -8.436169e-02 8.436169e-02 0.9964 -11.3731 64.7453)",
    fill: "#808989",
    cx: 760.4,
    cy: 166.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 705.9,
    y1: 154.5,
    x2: 695.9,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6177 -0.7864 0.7864 0.6177 148.3519 614.2017)",
    fill: "#808989",
    cx: 705.9,
    cy: 154.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6177 -0.7864 0.7864 0.6177 134.4915 611.1946)",
    fill: "#808989",
    cx: 695.9,
    cy: 167.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 688.4,
    y1: 161.7,
    x2: 695.9,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6027 -0.798 0.798 0.6027 144.5124 613.5562)",
    fill: "#808989",
    cx: 688.4,
    cy: 161.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6027 -0.798 0.798 0.6027 142.991 621.736)",
    fill: "#808989",
    cx: 695.9,
    cy: 167.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 695.9,
    y1: 167.3,
    x2: 740.9,
    y2: 151.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9465 -0.3228 0.3228 0.9465 -16.7454 233.5749)",
    fill: "#808989",
    cx: 695.9,
    cy: 167.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9465 -0.3228 0.3228 0.9465 -9.3701 247.2919)",
    fill: "#808989",
    cx: 740.9,
    cy: 151.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 687.7,
    y1: 167.7,
    x2: 695.9,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9986 -5.359064e-02 5.359064e-02 0.9986 -7.9996 37.0952)",
    fill: "#808989",
    cx: 687.7,
    cy: 167.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9986 -5.359064e-02 5.359064e-02 0.9986 -7.9644 37.5315)",
    fill: "#808989",
    cx: 695.9,
    cy: 167.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 697.4,
    y1: 18,
    x2: 686.1,
    y2: 28.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7256 -0.6881 0.6881 0.7256 178.9846 484.8329)",
    fill: "#808989",
    cx: 697.4,
    cy: 18,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7256 -0.6881 0.6881 0.7256 168.562 480.0222)",
    fill: "#808989",
    cx: 686.1,
    cy: 28.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 697.4,
    y1: 18,
    x2: 671.2,
    y2: 31.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8905 -0.455 0.455 0.8905 68.1743 319.2728)",
    fill: "#808989",
    cx: 697.4,
    cy: 18,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8905 -0.455 0.455 0.8905 59.2301 308.8362)",
    fill: "#808989",
    cx: 671.2,
    cy: 31.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 671.2,
    y1: 31.4,
    x2: 659.2,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7612 -0.6486 0.6486 0.7612 139.9737 442.8269)",
    fill: "#808989",
    cx: 671.2,
    cy: 31.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7612 -0.6486 0.6486 0.7612 146.2566 431.6382)",
    fill: "#808989",
    cx: 659.2,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 654.6,
    y1: 21.5,
    x2: 671.2,
    y2: 31.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5099 -0.8602 0.8602 0.5099 302.3053 573.6353)",
    fill: "#808989",
    cx: 654.6,
    cy: 21.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5099 -0.8602 0.8602 0.5099 301.9752 592.7781)",
    fill: "#808989",
    cx: 671.2,
    cy: 31.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 671.2,
    y1: 31.4,
    x2: 652.5,
    y2: 37.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9438 -0.3306 0.3306 0.9438 27.3662 223.6498)",
    fill: "#808989",
    cx: 671.2,
    cy: 31.4,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9438 -0.3306 0.3306 0.9438 24.1442 217.8206)",
    fill: "#808989",
    cx: 652.5,
    cy: 37.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 658.3,
    y1: 51.8,
    x2: 652.5,
    y2: 37.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9226 -0.3858 0.3858 0.9226 30.9789 257.9731)",
    fill: "#808989",
    cx: 658.3,
    cy: 51.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9226 -0.3858 0.3858 0.9226 35.8812 254.6616)",
    fill: "#808989",
    cx: 652.5,
    cy: 37.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 658.3,
    y1: 51.8,
    x2: 650.3,
    y2: 56
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8858 -0.4642 0.4642 0.8858 51.1687 311.4739)",
    fill: "#808989",
    cx: 658.3,
    cy: 51.8,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8858 -0.4642 0.4642 0.8858 48.3131 308.2444)",
    fill: "#808989",
    cx: 650.3,
    cy: 56,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 652.5,
    y1: 37.9,
    x2: 653.7,
    y2: 59.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9984 -5.603034e-02 5.603034e-02 0.9984 -1.0997 36.6201)",
    fill: "#808989",
    cx: 652.5,
    cy: 37.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9984 -5.603034e-02 5.603034e-02 0.9984 -2.2996 36.7213)",
    fill: "#808989",
    cx: 653.7,
    cy: 59.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 659.2,
    y1: 17.2,
    x2: 663.5,
    y2: 36.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9764 -0.2158 0.2158 0.9764 11.8085 142.6401)",
    fill: "#808989",
    cx: 659.2,
    cy: 17.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9764 -0.2158 0.2158 0.9764 7.6888 144.034)",
    fill: "#808989",
    cx: 663.5,
    cy: 36.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 652.5,
    y1: 37.9,
    x2: 663.5,
    y2: 36.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9949 -0.1011 0.1011 0.9949 -0.4896 66.1846)",
    fill: "#808989",
    cx: 652.5,
    cy: 37.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9949 -0.1011 0.1011 0.9949 -0.3201 67.2913)",
    fill: "#808989",
    cx: 663.5,
    cy: 36.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 697.4,
    y1: 18,
    x2: 701.1,
    y2: 28.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9392 -0.3434 0.3434 0.9392 36.2312 240.5911)",
    fill: "#808989",
    cx: 697.4,
    cy: 18,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9392 -0.3434 0.3434 0.9392 32.9623 242.4882)",
    fill: "#808989",
    cx: 701.1,
    cy: 28.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 701.1,
    y1: 28.2,
    x2: 752.8,
    y2: 17.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9808 -0.1949 0.1949 0.9808 7.9548 137.2002)",
    fill: "#808989",
    cx: 701.1,
    cy: 28.2,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9808 -0.1949 0.1949 0.9808 10.9471 147.0739)",
    fill: "#808989",
    cx: 752.8,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 752.8,
    y1: 17.9,
    x2: 779.3,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4811 -0.8767 0.8767 0.4811 374.9098 669.2235)",
    fill: "#808989",
    cx: 752.8,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4811 -0.8767 0.8767 0.4811 375.913 700.033)",
    fill: "#808989",
    cx: 779.3,
    cy: 32.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 785.8,
    y1: 16.7,
    x2: 779.3,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3814 -0.9244 0.9244 0.3814 470.6577 736.7272)",
    fill: "#808989",
    cx: 785.8,
    cy: 16.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3814 -0.9244 0.9244 0.3814 452.0371 740.4672)",
    fill: "#808989",
    cx: 779.3,
    cy: 32.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 792.2,
    y1: 21.7,
    x2: 779.3,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7673 -0.6413 0.6413 0.7673 170.4066 513.0593)",
    fill: "#808989",
    cx: 792.2,
    cy: 21.7,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7673 -0.6413 0.6413 0.7673 160.5293 507.3231)",
    fill: "#808989",
    cx: 779.3,
    cy: 32.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 792.7,
    y1: 29.6,
    x2: 779.3,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9779 -0.2091 0.2091 0.9779 11.3393 166.444)",
    fill: "#808989",
    cx: 792.7,
    cy: 29.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9779 -0.2091 0.2091 0.9779 10.4432 163.7037)",
    fill: "#808989",
    cx: 779.3,
    cy: 32.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 724,
    y1: 18.3,
    x2: 739.7,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6135 -0.7897 0.7897 0.6135 265.3125 578.7823)",
    fill: "#808989",
    cx: 724,
    cy: 18.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6135 -0.7897 0.7897 0.6135 261.7463 595.8995)",
    fill: "#808989",
    cx: 739.7,
    cy: 30.5,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 739.7,
    y1: 30.5,
    x2: 752.8,
    y2: 17.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7199 -0.6941 0.6941 0.7199 186.0106 521.9695)",
    fill: "#808989",
    cx: 739.7,
    cy: 30.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7199 -0.6941 0.6941 0.7199 198.4368 527.5192)",
    fill: "#808989",
    cx: 752.8,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 752.8,
    y1: 17.9,
    x2: 760.4,
    y2: 28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7957 -0.6057 0.6057 0.7957 142.9377 459.6011)",
    fill: "#808989",
    cx: 752.8,
    cy: 17.9,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7957 -0.6057 0.6057 0.7957 138.414 466.2866)",
    fill: "#808989",
    cx: 760.4,
    cy: 28,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 760.4,
    y1: 28,
    x2: 785.8,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.914 -0.4058 0.4058 0.914 54.0671 310.9564)",
    fill: "#808989",
    cx: 760.4,
    cy: 28,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.914 -0.4057 0.4057 0.914 60.8194 320.2762)",
    fill: "#808989",
    cx: 785.8,
    cy: 16.7,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 708.1,
    y1: 30.3,
    x2: 735.6,
    y2: 43.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4258 -0.9048 0.9048 0.4258 379.1184 658.1024)",
    fill: "#808989",
    cx: 708.1,
    cy: 30.3,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4258 -0.9048 0.9048 0.4258 383.1866 690.4056)",
    fill: "#808989",
    cx: 735.6,
    cy: 43.3,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 779.3,
    y1: 32.5,
    x2: 794.6,
    y2: 47.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7079 -0.7063 0.7063 0.7079 204.7049 559.9194)",
    fill: "#808989",
    cx: 779.3,
    cy: 32.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7079 -0.7063 0.7063 0.7079 198.3578 575.1715)",
    fill: "#808989",
    cx: 794.6,
    cy: 47.8,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 793.8,
    y1: 38.5,
    x2: 788.1,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5459 -0.8379 0.8379 0.5459 328.261 682.5716)",
    fill: "#808989",
    cx: 793.8,
    cy: 38.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5459 -0.8379 0.8379 0.5459 318.3572 681.7708)",
    fill: "#808989",
    cx: 788.1,
    cy: 47.2,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 793.8,
    y1: 38.5,
    x2: 791.6,
    y2: 51.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1672 -0.9859 0.9859 0.1672 623.1852 814.6667)",
    fill: "#808989",
    cx: 793.8,
    cy: 38.5,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1672 -0.9859 0.9859 0.1672 608.6299 823.2633)",
    fill: "#808989",
    cx: 791.6,
    cy: 51.4,
    rx: 1.6,
    ry: 1.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808989",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    x1: 710.4,
    y1: 60.6,
    x2: 735.6,
    y2: 94.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8023 -0.5969 0.5969 0.8023 104.2384 435.9989)",
    fill: "#808989",
    cx: 710.4,
    cy: 60.6,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8023 -0.5969 0.5969 0.8023 89.0182 457.71)",
    fill: "#808989",
    cx: 735.6,
    cy: 94.5,
    rx: 1.6,
    ry: 1.6
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "didot",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244,70.8c4.7,0,9.4,0.9,13.9,2.7l5.1,2.1c2.3,0.9,3.9,1.4,4.8,1.4c0.7,0,1.4-0.2,2.2-0.5l2.9-1.4 c0.4-0.2,0.8-0.3,1.2-0.3c1.1,0,1.6,0.8,1.6,2.5l-0.2,6.1c0,1,0,1.9,0.2,2.7l1,7.4l0.8,6.9c0.1,0.6,0.2,1.1,0.2,1.5 c0,2.2-0.6,3.2-1.9,3.2c-0.9,0-1.6-1-2-2.9c-1.5-7-5.1-13.1-11-18.2c-5.9-5.1-12.1-7.7-18.7-7.7c-4.5,0-8.5,1.5-11.9,4.6 c-3.4,3.1-5.1,6.7-5.1,10.8c0,3.9,1.5,7.2,4.5,10c1.9,1.8,7.9,4.8,17.9,8.8c4.8,2,9,3.9,12.5,5.8c5.2,2.9,9,5.7,11.3,8.5 c4.6,5.6,6.9,12.4,6.9,20.4c0,8.8-3.2,16.4-9.5,22.9c-6.3,6.5-13.8,9.7-22.3,9.7c-3.5,0-9-1.2-16.5-3.5c-3.5-1.2-6.1-1.9-7.8-2.3 c-2.3-0.5-3.7-0.9-4-1.3c-0.4-0.4-0.7-1.7-0.9-3.9c-0.3-2.4-1-5.8-2.3-10.3c-1.9-6.8-2.9-11.2-2.9-13.1c0-2.4,0.8-3.6,2.3-3.6 c0.7,0,1.2,0.6,1.5,1.8c2.5,8.6,6.8,15.9,12.8,21.8c6.1,5.9,12.4,8.8,19,8.8c5.1,0,9.6-1.9,13.6-5.8c4-3.9,6-8.3,6-13.4 c0-4-1-7.2-3.1-9.8c-2.1-2.6-5.7-5-10.8-7.2l-11.5-5.1c-5-2.2-9.3-4.4-12.8-6.6c-4.1-2.5-7.2-4.8-9.2-7.2 c-3.9-4.3-5.8-10-5.8-17.2c0-8.3,2.7-15.3,8.1-20.8C229.2,73.6,236,70.8,244,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.4,70.8c5.6,0,10.7,0.7,15.4,2.1c3.3,1,6.3,2.3,9.2,3.9l5,2.9c1,0.6,1.9,0.9,2.7,0.9c1,0,1.8-0.4,2.3-1.2l1.6-2.3 c0.3-0.4,0.7-0.6,1.4-0.6c1.6,0,2.3,1.6,2.3,4.9l0.1,5.5v6.9l0.6,5.7l0.7,3.4c0.3,1.7,0.5,3.1,0.5,4.5c0,1.9-0.7,2.9-2.1,2.9 c-0.8,0-1.3-0.6-1.6-1.8c-0.4-1.9-1.8-4.8-4.2-8.8c-2.4-3.9-4.7-7.1-6.8-9.4c-3.2-3.5-6.6-6.3-10.1-8.5c-6-3.8-12.4-5.7-19.2-5.7 c-9.5,0-17.2,3.9-23.2,11.7c-5.9,7.8-8.9,17.9-8.9,30.4c0,7.3,1,14,3,20c2.4,7.3,6.3,13.6,11.6,18.9c3.5,3.5,7.1,6.1,10.9,7.9 c4.1,2,8.5,3,13,3c5.1,0,10.5-1.2,16.2-3.6c5.7-2.4,10.2-5.4,13.4-9.1l4.9-5.3c0.7-0.8,1.4-1.2,2-1.3c1,0,1.4,0.5,1.4,1.7 c0,2.1-2,5.4-6,9.9c-3,3.4-6.3,6.4-9.8,8.8c-4.2,2.9-8.6,5.1-13.4,6.6c-4.8,1.5-10,2.2-15.4,2.2c-7.2,0-13.8-1.1-19.7-3.4 c-6.2-2.4-11.6-6-16.3-10.8c-4.3-4.4-7.6-9.5-9.9-15.1c-2.6-6.4-3.9-13.7-3.9-21.8c0-5.1,0.7-10.2,2-15.2 c0.8-3.1,1.9-6.1,3.2-9.1c2-4.6,4.4-8.8,7.2-12.4c2-2.6,4.2-4.9,6.6-7c4.8-4.1,9.9-7.1,15.5-9.2S337.1,70.8,343.4,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.4,152.4l0.6,7.5c0.6,3.9,2.1,6.8,4.4,8.9c2.3,2.1,5.4,3.1,9.2,3.1c2.5,0,3.7,0.8,3.7,2.3c0,1.5-1.6,2.2-4.9,2.2 c-1.4,0-3.4-0.1-6-0.4c-6.5-0.7-11.8-1.1-15.9-1.1c-5,0-9,0.3-11.9,0.8c-2.5,0.5-4.3,0.7-5.4,0.7c-1.1,0-1.8-0.5-2.1-1.6 l-0.2-0.6l2.2-1.8c3.6-1.3,6-2.9,7.2-4.8c1.2-1.9,1.8-5,1.8-9.4l0.1-6.7v-16.8v-26.3v-17c0-4.6-0.8-7.9-2.4-9.9 c-1.6-2-4.6-3.3-8.8-3.9c-2.6-0.4-4.2-0.8-4.9-1.2c-0.7-0.4-1.1-1-1.1-2c0-1.4,0.6-2.1,1.8-2.1c0.9,0.1,2.3,0.3,4.1,0.6 c1.8,0.4,4.9,0.6,9.1,0.6c2.8,0,6.3-0.2,10.5-0.5l5.5-0.4c5.2-0.4,9.2-0.6,11.9-0.6c1.7,0,2.5,0.6,2.5,1.8c0,0.9-0.1,1.5-0.4,1.8 c-0.3,0.3-0.9,0.5-1.9,0.7c-3.6,0.6-6,1.6-7,3c-1,1.4-1.5,4.3-1.5,8.6v16.3v24.3V152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.8,90.1v16.4c0,4.7,0.3,7.6,1,8.9c0.7,1.3,2.3,1.9,4.9,1.9l2.3-0.1l3.3-0.1h6.4c5,0,8.8-2.7,11.5-8.2l1.7-3.7 c0.5-0.9,1.2-1.4,2.3-1.4c1.1,0,1.7,0.6,1.7,2c0,0.4-0.1,1.5-0.2,3.3c-0.1,1.3-0.2,2.4-0.2,3.3c0,1.6,0.2,5.4,0.7,11.3 c0.3,3.9,0.5,7.3,0.5,10.1l0.1,3.9c0,0.7-0.1,1.2-0.2,1.4c-0.2,0.3-0.6,0.5-1.2,0.5c-1.3,0.1-2-0.9-2.3-2.9 c-0.7-4.3-2.2-7.5-4.5-9.7c-1.3-1.2-2.9-2-4.8-2.3c-1.9-0.4-5.4-0.5-10.6-0.5h-5.1c-2.4,0-4.1,0.4-4.9,1.1 c-0.9,0.7-1.5,2.2-1.8,4.4c-0.3,2.5-0.5,6.5-0.5,11.9v6.8c0,7.1,0.6,12.2,1.7,15.3c0.9,2.3,1.9,3.8,3,4.6 c1.2,0.8,2.9,1.2,5.4,1.2c7.3,0,13.6-0.8,19.1-2.4c5.5-1.6,10.1-3.9,13.8-7.1c3-2.5,5.4-5.6,7.2-9.2c0.4-0.6,0.7-0.9,0.9-1 c0.5-0.1,1,0.1,1.4,0.5c0.4,0.4,0.6,1,0.6,1.6c0,4.9-1.3,9.7-4,14.4c-2.2,3.9-5,6.7-8.3,8.4c-3.3,1.7-7.7,2.5-13.2,2.5 c-3.2,0-6.8-0.2-10.7-0.6l-8.8-0.8c-3.2-0.3-7.6-0.5-13.1-0.5c-3.7,0-9.3,0.2-16.8,0.7c-2.1,0.2-3.5,0.2-4.5,0.2 c-1.2,0-1.9-0.6-2-1.7c0-0.9,0.5-1.6,1.7-2.1c2.9-1.1,4.8-2.3,5.8-3.5c1-1.2,1.8-3.4,2.5-6.6c0.6-2.7,0.8-6.3,0.8-10.8v-23.8 v-19.7V91.9c0-5.6-0.9-9.4-2.8-11.5c-1.8-2-5.6-3.4-11.4-4.2c-1.4-0.2-2-0.9-2-2.2c0-1.2,0.8-1.8,2.5-1.8c0.4,0,1.1,0.1,2.3,0.2 c0.9,0.1,2.1,0.1,3.7,0.1l7.6,0.3l14.5,0.2l14.1,0.1c6.7,0,12.3,0,16.9-0.1c6.7-0.1,11.2-0.3,13.5-0.6c0.4,0,0.8-0.1,1.1-0.1 c1.5,0,2.2,0.8,2.2,2.5c0,1.2,0.2,3.2,0.5,6.2c0.4,4.4,0.6,7.5,0.6,9.4c0,3.8-1,5.8-2.9,5.9c-1,0.1-1.4-1.1-1.4-3.3 c0-5-1.8-8.6-5.5-10.9c-3.6-2.2-9.5-3.4-17.7-3.4h-9.2l-5.1,0.6c-2.6,0.8-3.8,3.3-3.8,7.6L479.8,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.8,89.8l9.1,10.2l10.8,12.1l10.4,11.7l9.6,10.8l2.6,2.9c3.4,3.8,5.7,5.7,6.9,5.7c1.1,0,1.6-1.5,1.7-4.6 c0.2-5.6,0.4-11.1,0.5-16.5c0.1-5.2,0.2-10.3,0.2-15.3c0-6.9-0.4-12.6-1.2-16.9c-0.6-3-1.4-5.4-2.3-7.1c-1.2-2.1-3-3.7-5.3-4.9 s-5.3-1.9-8.8-2.1c-1.7-0.1-2.5-0.7-2.5-1.8c0-1.3,0.7-2,2.2-2c1.8,0,4.7,0.3,8.8,0.8c2.6,0.3,4.8,0.5,6.5,0.5 c2.2,0,5.2-0.2,8.9-0.6c2.3-0.2,4.8-0.5,7.6-0.9c1-0.1,1.7-0.2,2.2-0.2c1.6,0,2.4,0.7,2.4,2.1c0,1.3-0.8,2-2.4,2.3 c-1.9,0.4-3.6,1.1-4.9,2.3c-1.5,1.3-2.7,3.2-3.5,5.6c-0.9,2.5-1.3,5.7-1.3,9.4v3.7l-0.5,22.6l-0.6,24.5l-0.3,6.5l-0.1,8.4 l0.1,5.7l0.3,9.4c0,1.4-0.5,2.1-1.5,2c-0.9-0.1-1.8-0.6-2.8-1.7l-15.1-16.8l-17.5-19.5l-15.6-17.4l-20.4-22.6c-1.2-1.3-2-2-2.5-2 c-1.2,0-1.8,1.1-1.8,3.4l-0.1,2.2v13.5v15.8c0,6.4,0.1,11.9,0.4,16.5c0.4,6.8,1,11.7,2,14.9c1.7,5.6,6.6,8.8,14.7,9.6 c1.5,0.2,2.3,0.8,2.3,1.9c0,1.5-0.8,2.3-2.3,2.3c-0.6,0-1.6-0.1-2.9-0.3c-4.2-0.7-8.9-1.1-14.1-1.1c-5.1,0-9.6,0.4-13.6,1.1 c-1.8,0.3-3.1,0.4-3.9,0.4c-1.4,0-2-0.6-2-1.8c0-1,0.7-1.7,2.2-2.2c3.7-1.1,6.4-3.2,8-6.5c1.7-3.3,2.5-8,2.5-14.2l0.5-17.9v-32.7 c0-5.8-0.8-10.6-2.4-14.3c-1.3-3-3.1-5.4-5.5-7c-2.5-1.8-5.6-2.8-9.3-3.1c-1.6-0.1-2.3-0.7-2.3-1.9c0-1.4,0.9-2.2,2.6-2.2 l5.2,0.2l3.2-0.1c3.9,0,8.1-0.2,12.6-0.7c1.7-0.2,3.1-0.2,4.2-0.2c1.6,0,2.8,0.3,3.7,1s2.8,2.8,5.7,6.2l5.2,6.1 C578.2,87.9,579.4,89.3,579.8,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.2,90.9v14v21.3v21.5c0,8.5,1.2,14.5,3.7,18.1s6.8,5.5,13.1,5.9c1.8,0.2,2.7,1,2.7,2.7c0,1.2-0.8,1.8-2.3,1.8 c-0.4,0-1,0-1.9-0.1l-5.7-0.2l-9.4-0.6c-0.8,0-1.8-0.1-3-0.1c-2.9,0-5.5,0.1-7.8,0.2l-16.7,1c-1.8,0.2-3,0.3-3.6,0.3 c-1.6,0-2.3-0.7-2.3-2c0-1.1,0.3-1.9,0.8-2.2c0.5-0.3,1.4-0.5,2.9-0.7c3.9-0.3,7-1.7,9.1-4.3c2.1-2.6,3.2-6.1,3.2-10.6l-0.1-3.5 v-15.9v-18.7v-16V86.4c0-2-0.5-3.5-1.6-4.5s-2.7-1.5-4.8-1.5c-3.9,0-7.4,0.1-10.3,0.3c-4.6,0.3-8,1-10.3,1.9 c-2.7,1.1-4.4,2.4-5.3,3.7c-0.9,1.4-2.1,4.8-3.6,10.3l-0.6,2.1c-0.6,2.1-1.4,3.1-2.6,3.1c-1.7,0-2.4-0.8-2.3-2.3 c0-1.4,0.3-3.4,0.8-5.9l0.8-6.6l0.9-6.7l0.5-4.6c0.2-2,1.3-2.9,3.2-2.9c0.5,0,1.4,0.1,2.6,0.2c2,0.2,4.8,0.2,8.4,0.2l15.4,0.2 l18.3,0.2c6.4,0,13-0.1,19.9-0.3c5.8-0.2,11.7-0.4,17.7-0.7c2.6-0.1,4.3-0.2,5.1-0.2c2.8,0,4.2,1.2,4.4,3.5l0.4,5.4 c0,0.9,0.3,2.9,0.8,6.1c0.4,2.7,0.5,4.8,0.5,6.4c0,1.7-0.7,2.5-2,2.5c-1.2,0-2-1-2.4-2.9c-0.5-2.3-1.3-4.3-2.3-6 c-1-1.7-2.3-3.1-3.8-4.2c-3-2.1-7.3-3.1-13-3.1c-2.8,0-5.2,0.1-7.2,0.2c-3.5,0.3-5.9,0.8-7.1,1.5 C712.2,83.3,711.2,86.2,711.2,90.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 217.5953 232.6356)",
    fontFamily: "'GoudyOldStyleT-Bold'",
    fontSize: "50.8017px"
  }, "ASSET MANAGEMENT")), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    d: "M112.3,8l19.3,3.8l7,2.9l6.7,1.9l8.7-3.1 l2.2,3.5l-0.2,8.5l0.2,3.8l1.4,10.3l1,9.6l0.2,2.1l-2.6,4.5l-2.7-4l-15.4-25.3l-26.1-10.7l-16.5,6.4l-7,15.1l6.2,13.9l24.9,12.3 l33,20l9.6,28.4L149,143.5l-31,13.5l-23-4.9l-10.8-3.1l-5.6-1.8l-1.3-5.4l-3.1-14.3l-4-18.3l5.4-2.5l17.9,30.3l26.4,12.3l19-8.1 l8.4-18.6l-4.4-13.6l-15.1-10l-16-7.1L81,72.6l-8.1-23.9l11.3-29L112.3,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    points: "112.3,8 131.6,11.8 138.6,14.8  145.3,16.7 154.1,13.5 156.3,17 156.1,25.5 156.3,29.3 157.6,39.5 158.7,49.1 158.9,51.2 156.3,55.7 153.6,51.7 138.2,26.4  112.1,15.7 95.6,22.1 88.6,37.1 94.8,51.1 119.7,63.3 152.7,83.3 162.3,111.6 149,143.5 118.1,157 95.1,152.1 84.3,148.9  78.6,147.1 77.3,141.7 74.2,127.4 70.2,109.1 75.6,106.6 93.4,136.9 119.8,149.1 138.8,141 147.1,122.4 142.8,108.8  127.7,98.8 111.7,91.7 81,72.6 72.9,48.7 84.2,19.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1921 -0.9814 0.9814 0.1921 82.8229 116.6965)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9235 -0.3835 0.3835 0.9235 5.4999 43.6789)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })))))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 109.1,
    x2: 75.6,
    y2: 106.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -39.8626 40.3922)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -38.2725 42.4354)",
    cx: 75.6,
    cy: 106.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 91.8,
    y1: 146.2,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -61.0831 66.0068)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -45.3778 50.1324)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 78.6,
    y1: 147.1,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.956132e-02 6.956132e-02 0.9976 -10.0414 5.8271)",
    cx: 78.6,
    cy: 147.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.955907e-02 6.955907e-02 0.9976 -9.9458 6.7365)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 118.1,
    y1: 157,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3807 -0.9247 0.9247 0.3807 -72.0727 206.4049)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3808 -0.9247 0.9247 0.3808 -78.3481 175.3658)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.8,
    y1: 149.1,
    x2: 118.1,
    y2: 157
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -51.7202 233.8399)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -60.7742 238.3055)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 119.8,
    y2: 149.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -24.6115 31.035)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -26.2286 25.5692)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.8,
    y1: 141,
    x2: 149,
    y2: 143.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -30.5266 243.4178)",
    cx: 138.8,
    cy: 141,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -25.0207 255.2617)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 147.1,
    y1: 122.4,
    x2: 162.3,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -43.7677 108.3983)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -34.6654 115.1743)",
    cx: 162.3,
    cy: 111.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -12.247 13.9206)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -10.3727 13.667)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 152.7,
    y1: 83.3,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 48.8081 222.7836)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 5.2607 250.955)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -10.3301 202.5937)",
    cx: 142.8,
    cy: 108.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 19.824 195.5237)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 127.7,
    y1: 98.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -32.8937 82.1504)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -20.9647 92.9988)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -16.0909 24.2259)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -13.5841 32.2621)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.1,73.2"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 109.1,
    y1: 73.2,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -9.2168 16.0888)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -11.7928 16.643)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -11.0967 98.4195)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -20.6361 93.8397)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -8.2817 81.7913)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -12.6618 122.4962)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 6.7567 152.0878)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 33.6575 180.7221)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 81,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 0.7432 103.4671)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 -23.7635 101.8277)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 88.6,
    y1: 37.1,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -4.7469 59.8774)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -14.6674 52.8444)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 84.2,
    y1: 19.7,
    x2: 88.6,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -2.2654 21.0115)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -6.3653 22.5898)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 95.6,
    y1: 22.1,
    x2: 84.2,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 54.4371 111.1647)",
    cx: 95.6,
    cy: 22.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 47.6967 98.1049)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.3,
    y1: 8,
    x2: 112.1,
    y2: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 101.8367 120.1343)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 94.0143 127.4699)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 131.6,
    y1: 11.8,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 6.857 55.3875)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 1.4329 59.4125)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.1,
    y1: 15.7,
    x2: 131.6,
    y2: 11.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -0.9073 22.2331)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 0.2285 25.9672)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -12.2308 62.8391)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -33.5128 89.9774)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 26.3139 161.3967)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 -6.7688 174.3845)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 157.6,
    y1: 39.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 36.5793 147.9773)",
    cx: 157.6,
    cy: 39.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 38.9201 126.0855)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 17,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 9.8406 74.1275)",
    cx: 156.3,
    cy: 17,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 3.4425 66.8391)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 154.1,
    y1: 13.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 25.9362 100.1191)",
    cx: 154.1,
    cy: 13.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 14.2673 92.9962)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.6,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 34.5216 131.4978)",
    cx: 156.3,
    cy: 29.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 39.2668 112.5572)",
    cx: 138.6,
    cy: 14.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 145.3,
    y1: 16.7,
    x2: 156.3,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 0.8918 39.8042)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 -9.2325 44.1998)",
    cx: 156.3,
    cy: 55.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 158.9,
    y1: 51.2,
    x2: 145.3,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 -7.718 61.6075)",
    cx: 158.9,
    cy: 51.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 3.9652 54.2631)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -57.8107 204.6665)",
    cx: 93.4,
    cy: 136.9,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -68.3293 210.6766)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 75.6,
    y1: 106.6,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 162.3,
    y1: 111.6,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 119.7,
    y2: 63.3
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 96.8,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 88.8,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.2,
    y1: 26.4,
    x2: 112.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.5,7.2l1,4.5l2.1,6l3.4,6.5l5,6.2l6.3,5l5.8,2.5l5.3,0.9l4.6,0.1l12.4-2.3l7.6-5.8l3.9-7.2l1.1-6.6l-2.5-8.7L261,2.5 l-9.4-3.8l-10.8-3.2L230-8.3l-9.4-5.7l-6.6-8.6l-2.5-12.8l2.6-11l7.1-9.3l10.9-6.5l13.7-2.5l8.2,0.9l6.3,1.8l4.8,1.8l3.8,0.9 l2.6-0.6l1.4-2.3h2.3v27h-1.8l-3.6-9.8l-4.9-8.7l-7.5-6.3l-11.5-2.4l-10,1.6l-7.3,4.1l-4.6,5.7l-1.6,6.4l2.6,8.2l6.9,5.6l9.7,4.1 l11.2,3.6l11.2,4.1l9.7,5.6l6.9,8.2l2.6,11.9l-2.8,13.2l-8,11L259.9,38l-16,2.8l-8.7-0.9l-8.1-1.8l-6.7-1.8l-4.3-0.9l-2.8,0.6 l-1.6,2.6h-2.3V7.2H211.5L211.5,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.2-33.4l-3.8-9.9l-5.7-9.5L366-60l-12.9-2.8l-16.4,3.8l-9,10.7l-3.9,16.3L323-11.2l1.7,24.5l5.3,15.4l9.4,8l13.7,2.3 l11.6-2.6l9.2-6.8l6.7-9.6l4-11.2h2.3v30.2h-2.3l-1.7-2.3l-3-0.6l-4.4,0.8l-6.2,1.7l-7.6,1.7l-8.7,0.8L333,36.7l-17-11.1 L304.2,9.1l-4.4-20.6l4.9-21.9l12.6-16.8L334.5-61l18.6-3.8l8.5,0.9l7.3,1.8l6,1.8l4.6,0.9l3-0.5l1.4-2.5h2.3v29H384.2L384.2-33.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.6-62.4v2h-13.1v97.3h13.1v2h-46.8v-2h13.1v-97.3h-13.1v-2H447.6L447.6-62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.5-62.4v24.3h-1.8l-2.4-6.2l-4.8-7.3l-7.9-6.2l-11.8-2.6h-22.6v43.9h8L509-18l6-4.3l4-6.7l2.6-8.7h1.8V6.5h-1.8 l-2.3-8l-3.6-6.8l-5.6-4.6l-8.3-1.7h-9.5v51.3h23.3l11.8-2.2l9.3-6.2l6.8-9.3l4.1-11.4h1.8v31.1h-90.9v-2h13.1v-97.3h-13.1v-2 H543.5L543.5-62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.2-62.4l47.4,67.7h0.3v-65.7h-13.1v-2h28.4v2h-13.1v99.3h-3.8l-64-91.2H576v89.2h13.1v2h-28.4v-2h13.1v-97.3h-13.1v-2 H594.2L594.2-62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.9-60.5l-9.4,1.1l-7.4,3.7l-5.8,7.3l-4.7,11.9h-1.8v-26h89.2v26h-1.8l-4.7-11.9l-5.8-7.3l-7.4-3.7l-9.4-1.1h-5.1v97.3 h13.1v2h-46.8v-2H701v-97.3H695.9L695.9-60.5z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "DIN",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 217.5953 232.6356)",
    fontFamily: "'GoudyOldStyleT-Bold'",
    fontSize: "50.8017px"
  }, "ASSET MANAGEMENT")), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    d: "M112.3,8l19.3,3.8l7,2.9l6.7,1.9l8.7-3.1 l2.2,3.5l-0.2,8.5l0.2,3.8l1.4,10.3l1,9.6l0.2,2.1l-2.6,4.5l-2.7-4l-15.4-25.3l-26.1-10.7l-16.5,6.4l-7,15.1l6.2,13.9l24.9,12.3 l33,20l9.6,28.4L149,143.5l-31,13.5l-23-4.9l-10.8-3.1l-5.6-1.8l-1.3-5.4l-3.1-14.3l-4-18.3l5.4-2.5l17.9,30.3l26.4,12.3l19-8.1 l8.4-18.6l-4.4-13.6l-15.1-10l-16-7.1L81,72.6l-8.1-23.9l11.3-29L112.3,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    points: "112.3,8 131.6,11.8 138.6,14.8  145.3,16.7 154.1,13.5 156.3,17 156.1,25.5 156.3,29.3 157.6,39.5 158.7,49.1 158.9,51.2 156.3,55.7 153.6,51.7 138.2,26.4  112.1,15.7 95.6,22.1 88.6,37.1 94.8,51.1 119.7,63.3 152.7,83.3 162.3,111.6 149,143.5 118.1,157 95.1,152.1 84.3,148.9  78.6,147.1 77.3,141.7 74.2,127.4 70.2,109.1 75.6,106.6 93.4,136.9 119.8,149.1 138.8,141 147.1,122.4 142.8,108.8  127.7,98.8 111.7,91.7 81,72.6 72.9,48.7 84.2,19.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1921 -0.9814 0.9814 0.1921 82.8229 116.6965)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9235 -0.3835 0.3835 0.9235 5.4999 43.6789)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })))))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 109.1,
    x2: 75.6,
    y2: 106.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -39.8626 40.3922)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -38.2725 42.4354)",
    cx: 75.6,
    cy: 106.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 91.8,
    y1: 146.2,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -61.0831 66.0068)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -45.3778 50.1324)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 78.6,
    y1: 147.1,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.956132e-02 6.956132e-02 0.9976 -10.0414 5.8271)",
    cx: 78.6,
    cy: 147.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.955907e-02 6.955907e-02 0.9976 -9.9458 6.7365)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 118.1,
    y1: 157,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3807 -0.9247 0.9247 0.3807 -72.0727 206.4049)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3808 -0.9247 0.9247 0.3808 -78.3481 175.3658)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.8,
    y1: 149.1,
    x2: 118.1,
    y2: 157
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -51.7202 233.8399)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -60.7742 238.3055)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 119.8,
    y2: 149.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -24.6115 31.035)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -26.2286 25.5692)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.8,
    y1: 141,
    x2: 149,
    y2: 143.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -30.5266 243.4178)",
    cx: 138.8,
    cy: 141,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -25.0207 255.2617)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 147.1,
    y1: 122.4,
    x2: 162.3,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -43.7677 108.3983)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -34.6654 115.1743)",
    cx: 162.3,
    cy: 111.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -12.247 13.9206)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -10.3727 13.667)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 152.7,
    y1: 83.3,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 48.8081 222.7836)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 5.2607 250.955)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -10.3301 202.5937)",
    cx: 142.8,
    cy: 108.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 19.824 195.5237)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 127.7,
    y1: 98.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -32.8937 82.1504)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -20.9647 92.9988)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -16.0909 24.2259)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -13.5841 32.2621)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.1,73.2"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 109.1,
    y1: 73.2,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -9.2168 16.0888)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -11.7928 16.643)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -11.0967 98.4195)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -20.6361 93.8397)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -8.2817 81.7913)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -12.6618 122.4962)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 6.7567 152.0878)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 33.6575 180.7221)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 81,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 0.7432 103.4671)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 -23.7635 101.8277)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 88.6,
    y1: 37.1,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -4.7469 59.8774)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -14.6674 52.8444)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 84.2,
    y1: 19.7,
    x2: 88.6,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -2.2654 21.0115)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -6.3653 22.5898)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 95.6,
    y1: 22.1,
    x2: 84.2,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 54.4371 111.1647)",
    cx: 95.6,
    cy: 22.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 47.6967 98.1049)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.3,
    y1: 8,
    x2: 112.1,
    y2: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 101.8367 120.1343)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 94.0143 127.4699)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 131.6,
    y1: 11.8,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 6.857 55.3875)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 1.4329 59.4125)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.1,
    y1: 15.7,
    x2: 131.6,
    y2: 11.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -0.9073 22.2331)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 0.2285 25.9672)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -12.2308 62.8391)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -33.5128 89.9774)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 26.3139 161.3967)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 -6.7688 174.3845)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 157.6,
    y1: 39.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 36.5793 147.9773)",
    cx: 157.6,
    cy: 39.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 38.9201 126.0855)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 17,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 9.8406 74.1275)",
    cx: 156.3,
    cy: 17,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 3.4425 66.8391)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 154.1,
    y1: 13.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 25.9362 100.1191)",
    cx: 154.1,
    cy: 13.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 14.2673 92.9962)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.6,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 34.5216 131.4978)",
    cx: 156.3,
    cy: 29.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 39.2668 112.5572)",
    cx: 138.6,
    cy: 14.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 145.3,
    y1: 16.7,
    x2: 156.3,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 0.8918 39.8042)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 -9.2325 44.1998)",
    cx: 156.3,
    cy: 55.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 158.9,
    y1: 51.2,
    x2: 145.3,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 -7.718 61.6075)",
    cx: 158.9,
    cy: 51.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 3.9652 54.2631)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -57.8107 204.6665)",
    cx: 93.4,
    cy: 136.9,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -68.3293 210.6766)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 75.6,
    y1: 106.6,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 162.3,
    y1: 111.6,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 119.7,
    y2: 63.3
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 96.8,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 88.8,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.2,
    y1: 26.4,
    x2: 112.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.4208 179.3761)",
    display: "inline",
    fontFamily: "'DIN-Bold'",
    fontSize: "160.4112px"
  }, "SCIENT"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "DIN_-_copie",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 217.5953 232.6356)",
    fontFamily: "'GoudyOldStyleT-Bold'",
    fontSize: "50.8017px"
  }, "ASSET MANAGEMENT")), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    d: "M112.3,8l19.3,3.8l7,2.9l6.7,1.9l8.7-3.1 l2.2,3.5l-0.2,8.5l0.2,3.8l1.4,10.3l1,9.6l0.2,2.1l-2.6,4.5l-2.7-4l-15.4-25.3l-26.1-10.7l-16.5,6.4l-7,15.1l6.2,13.9l24.9,12.3 l33,20l9.6,28.4L149,143.5l-31,13.5l-23-4.9l-10.8-3.1l-5.6-1.8l-1.3-5.4l-3.1-14.3l-4-18.3l5.4-2.5l17.9,30.3l26.4,12.3l19-8.1 l8.4-18.6l-4.4-13.6l-15.1-10l-16-7.1L81,72.6l-8.1-23.9l11.3-29L112.3,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    points: "112.3,8 131.6,11.8 138.6,14.8  145.3,16.7 154.1,13.5 156.3,17 156.1,25.5 156.3,29.3 157.6,39.5 158.7,49.1 158.9,51.2 156.3,55.7 153.6,51.7 138.2,26.4  112.1,15.7 95.6,22.1 88.6,37.1 94.8,51.1 119.7,63.3 152.7,83.3 162.3,111.6 149,143.5 118.1,157 95.1,152.1 84.3,148.9  78.6,147.1 77.3,141.7 74.2,127.4 70.2,109.1 75.6,106.6 93.4,136.9 119.8,149.1 138.8,141 147.1,122.4 142.8,108.8  127.7,98.8 111.7,91.7 81,72.6 72.9,48.7 84.2,19.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1921 -0.9814 0.9814 0.1921 82.8229 116.6965)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9235 -0.3835 0.3835 0.9235 5.4999 43.6789)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })))))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 70.2,
    y1: 109.1,
    x2: 75.6,
    y2: 106.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -39.8626 40.3922)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9044 -0.4267 0.4267 0.9044 -38.2725 42.4354)",
    cx: 75.6,
    cy: 106.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 91.8,
    y1: 146.2,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -61.0831 66.0068)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8642 -0.5031 0.5031 0.8642 -45.3778 50.1324)",
    cx: 70.2,
    cy: 109.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 78.6,
    y1: 147.1,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.956132e-02 6.956132e-02 0.9976 -10.0414 5.8271)",
    cx: 78.6,
    cy: 147.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9976 -6.955907e-02 6.955907e-02 0.9976 -9.9458 6.7365)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 118.1,
    y1: 157,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3807 -0.9247 0.9247 0.3807 -72.0727 206.4049)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3808 -0.9247 0.9247 0.3808 -78.3481 175.3658)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.8,
    y1: 149.1,
    x2: 118.1,
    y2: 157
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -51.7202 233.8399)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2164 -0.9763 0.9763 0.2164 -60.7742 238.3055)",
    cx: 118.1,
    cy: 157,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 119.8,
    y2: 149.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -24.6115 31.035)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9817 -0.1906 0.1906 0.9817 -26.2286 25.5692)",
    cx: 119.8,
    cy: 149.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.8,
    y1: 141,
    x2: 149,
    y2: 143.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -30.5266 243.4178)",
    cx: 138.8,
    cy: 141,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2314 -0.9729 0.9729 0.2314 -25.0207 255.2617)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 147.1,
    y1: 122.4,
    x2: 162.3,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -43.7677 108.3983)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8135 -0.5815 0.5815 0.8135 -34.6654 115.1743)",
    cx: 162.3,
    cy: 111.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 149,
    y1: 143.5,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -12.247 13.9206)",
    cx: 149,
    cy: 143.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.996 -8.953795e-02 8.953795e-02 0.996 -10.3727 13.667)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 152.7,
    y1: 83.3,
    x2: 147.1,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 48.8081 222.7836)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1403 -0.9901 0.9901 0.1403 5.2607 250.955)",
    cx: 147.1,
    cy: 122.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 -10.3301 202.5937)",
    cx: 142.8,
    cy: 108.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3617 -0.9323 0.9323 0.3617 19.824 195.5237)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 127.7,
    y1: 98.8,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -32.8937 82.1504)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8498 -0.5271 0.5271 0.8498 -20.9647 92.9988)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 152.7,
    y2: 83.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -16.0909 24.2259)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 -0.2002 0.2002 0.9797 -13.5841 32.2621)",
    cx: 152.7,
    cy: 83.3,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.1,73.2"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 109.1,
    y1: 73.2,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -9.2168 16.0888)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.99 -0.1408 0.1408 0.99 -11.7928 16.643)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -11.0967 98.4195)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7325 -0.6808 0.6808 0.7325 -20.6361 93.8397)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -8.2817 81.7913)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5606 -0.8281 0.8281 0.5606 -12.6618 122.4962)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 109.1,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 6.7567 152.0878)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.080177e-02 -0.9998 0.9998 2.080177e-02 33.6575 180.7221)",
    cx: 109.1,
    cy: 73.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 81,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 0.7432 103.4671)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5381 -0.8429 0.8429 0.5381 -23.7635 101.8277)",
    cx: 81,
    cy: 72.6,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 88.6,
    y1: 37.1,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -4.7469 59.8774)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8044 -0.594 0.594 0.8044 -14.6674 52.8444)",
    cx: 72.9,
    cy: 48.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 84.2,
    y1: 19.7,
    x2: 88.6,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -2.2654 21.0115)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9701 -0.2425 0.2425 0.9701 -6.3653 22.5898)",
    cx: 88.6,
    cy: 37.1,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 95.6,
    y1: 22.1,
    x2: 84.2,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 54.4371 111.1647)",
    cx: 95.6,
    cy: 22.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2045 -0.9789 0.9789 0.2045 47.6967 98.1049)",
    cx: 84.2,
    cy: 19.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.3,
    y1: 8,
    x2: 112.1,
    y2: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 101.8367 120.1343)",
    cx: 112.3,
    cy: 8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.140149e-02 -0.9998 0.9998 2.140149e-02 94.0143 127.4699)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 131.6,
    y1: 11.8,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 6.857 55.3875)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9108 -0.4129 0.4129 0.9108 1.4329 59.4125)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 112.1,
    y1: 15.7,
    x2: 131.6,
    y2: 11.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 -0.9073 22.2331)",
    cx: 112.1,
    cy: 15.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9807 -0.1956 0.1956 0.9807 0.2285 25.9672)",
    cx: 131.6,
    cy: 11.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 94.8,
    y1: 51.1,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -12.2308 62.8391)",
    cx: 94.8,
    cy: 51.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8232 -0.5678 0.5678 0.8232 -33.5128 89.9774)",
    cx: 127.7,
    cy: 98.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 119.7,
    y1: 63.3,
    x2: 111.7,
    y2: 91.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 26.3139 161.3967)",
    cx: 119.7,
    cy: 63.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2708 -0.9626 0.9626 0.2708 -6.7688 174.3845)",
    cx: 111.7,
    cy: 91.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 157.6,
    y1: 39.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 36.5793 147.9773)",
    cx: 157.6,
    cy: 39.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5602 -0.8284 0.8284 0.5602 38.9201 126.0855)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 17,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 9.8406 74.1275)",
    cx: 156.3,
    cy: 17,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8869 -0.462 0.462 0.8869 3.4425 66.8391)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 154.1,
    y1: 13.5,
    x2: 138.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 25.9362 100.1191)",
    cx: 154.1,
    cy: 13.5,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7764 -0.6302 0.6302 0.7764 14.2673 92.9962)",
    cx: 138.2,
    cy: 26.4,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.6,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 34.5216 131.4978)",
    cx: 156.3,
    cy: 29.3,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6344 -0.773 0.773 0.6344 39.2668 112.5572)",
    cx: 138.6,
    cy: 14.8,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 145.3,
    y1: 16.7,
    x2: 156.3,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 0.8918 39.8042)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.963 -0.2696 0.2696 0.963 -9.2325 44.1998)",
    cx: 156.3,
    cy: 55.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 158.9,
    y1: 51.2,
    x2: 145.3,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 -7.718 61.6075)",
    cx: 158.9,
    cy: 51.2,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3654 0.3654 0.9308 3.9652 54.2631)",
    cx: 145.3,
    cy: 16.7,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 91.8,
    y2: 146.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -57.8107 204.6665)",
    cx: 93.4,
    cy: 136.9,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1766 -0.9843 0.9843 0.1766 -68.3293 210.6766)",
    cx: 91.8,
    cy: 146.2,
    rx: 1.7,
    ry: 1.7
  })))), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 93.4,
    y1: 136.9,
    x2: 70.2,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 75.6,
    y1: 106.6,
    x2: 78.6,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 162.3,
    y1: 111.6,
    x2: 127.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 111.7,
    y1: 91.7,
    x2: 72.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 142.8,
    y1: 108.8,
    x2: 119.7,
    y2: 63.3
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 72.9,
    y1: 48.7,
    x2: 96.8,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 81,
    y1: 72.6,
    x2: 88.8,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 138.2,
    y1: 26.4,
    x2: 112.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    x1: 156.3,
    y1: 29.3,
    x2: 138.2,
    y2: 26.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientLogo);
export default __webpack_public_path__ + "static/media/scient-logo.39d2a8fc869f7a30ef26f20c10b6ffa9.svg";
export { ForwardRef as ReactComponent };